<template>
	<form-wizard
		@on-loading="setLoading"
		@on-change="changePage"
		class="bg-white"
		finish-button-text="Finalizar"
		back-button-text="Regresar"
		next-button-text="Siguiente"
		shape="tab"
		color="#97CA3D"
		v-if="formData.noError"
		:start-index="Number(initialStep)"
		id="formMultiStep"
	>
		<!-- informacion para el header -->
		<div class="" slot="title">
			<CRow style="padding: 10px;">
				<h5>
					Registrarte en el directorio #1 de Venezuela y mantener tus
					datos actualizados es el primer paso para empezar tu
					recorrido en el mundo online. Mientras más específica sea la
					información que suministres, más probabilidades tienes de
					que alguien te contacte. ¡Acompáñanos!
				</h5>
			</CRow>
		</div>
		<!-- mensaje de rechazo de la solicitud -->
		<CRow
			v-if="commetRejected != null"
			class="content-center"
			style="text-align:left;"
		>
			<CCol sm="9">
				<CAlert color="warning">
					<p>
						Su solicitud de actualización fue rechazada, por la
						siguiente razón: <b>{{ commetRejected.description }}</b>
					</p>
					<!-- <p>{{ commetRejected.description }}</p> -->
				</CAlert>
			</CCol>
		</CRow>
		<!-- cenefa con error de api -->
		<error-alert v-if="errorsAPI" :error-message="errorsAPI" />
		<!-- <CRow
			class="content-center"
			style="text-align:left;"
		>
			<CCol sm="9">
				<CAlert color="danger"
							>Oops!! El formulario tiene algún error. Por favor
							verifique los campos.</CAlert
						>
			</CCol>
		</CRow> -->
		<!-- paso 1 del formulario -->
		<tab-content
			title="Datos de la Empresa"
			ref="step1"
			:before-change="saveStep1"
		>
			<CContainer class="d-flex content-center min-vh-100">
				<div class="col-sm-12">
					<ValidationObserver v-slot="{ valid }">
						<CAlert v-if="!valid" color="danger"
							>Oops!! El formulario tiene algún error. Por favor
							verifique los campos.</CAlert
						>
						<input
							type="hidden"
							id="validStep1"
							ref="validStep1"
							class="hidden"
							:value="valid"
						/>
						<!-- rif, nombre y tipo de empresa -->
						<CRow class="content-center" style="text-align:left;">
							<CCol sm="12">
								<CCard>
									<CCardHeader>
										<strong
											>RIF, nombre y tipo de atención al
											público</strong
										>
									</CCardHeader>
									<CCardBody>
										<CRow
											class="content-center"
											style="text-align:left;"
										>
											<CCol sm="11">
												<ValidationProvider
													name="RIF"
													rules="validFiscalID|required"
													immediate
													v-slot="{ valid, errors }"
												>
													<CInput
														v-maska="{
															mask:
																'Z-########-#',
															tokens: {
																Z: {
																	pattern: /[VvEeJjPpGg]/,
																},
															},
														}"
														@change="
															handleChange(
																'dif',
																$refs.dif.value,
																'step1'
															)
														"
														@keyup="uppercase"
														v-model.trim="
															formData.dataStep1
																.dif
														"
														label="RIF"
														placeholder="RIF"
														id="dif"
														ref="dif"
														:isValid="valid"
													>
														<template
															#invalid-feedback
														>
															<span
																class="invalid-feedback"
																>{{
																	errors[0]
																}}</span
															>
														</template>
														<template #description>
															<span
																class="style-description"
																>Ingrese el RIF
																de su empresa
																Ej:
																J-12345678-9</span
															>
														</template>
													</CInput>
												</ValidationProvider>
											</CCol>
										</CRow>
										<CRow
											class="content-center"
											style="text-align:left;"
										>
											<CCol sm="11">
												<ValidationProvider
													name="Nombre Comercial"
													rules="required"
													immediate
													v-slot="{ valid, errors }"
												>
													<CInput
														@change="
															handleChange(
																'nameCommercial',
																$refs
																	.nameCommercial
																	.value,
																'step1'
															)
														"
														ref="nameCommercial"
														v-model.trim="
															formData.dataStep1
																.nameCommercial
														"
														label="Nombre Comercial"
														id="nameCommercial"
														:isValid="valid"
													>
														<template
															#invalid-feedback
														>
															<span
																class="invalid-feedback"
																>{{
																	errors[0]
																}}</span
															>
														</template>
														<template #description>
															<span
																class="style-description"
																>Ingrese el
																nombre comercial
																de su
																empresa</span
															>
														</template>
													</CInput>
												</ValidationProvider>
											</CCol>
										</CRow>
										<CRow
											class="content-center"
											style="text-align:left;"
										>
											<CCol sm="11">
												<ValidationProvider
													name="Nombre Fiscal"
													rules="required"
													immediate
													v-slot="{ valid, errors }"
												>
													<CInput
														v-model.trim="
															formData.dataStep1
																.namefiscal
														"
														@change="
															handleChange(
																'namefiscal',
																$refs.namefiscal
																	.value,
																'step1'
															)
														"
														ref="namefiscal"
														label="Nombre Fiscal"
														id="fiscalname"
														:isValid="valid"
													>
														<template
															#invalid-feedback
														>
															<span
																class="invalid-feedback"
																>{{
																	errors[0]
																}}</span
															>
														</template>
														<template #description>
															<span
																class="style-description"
																>Ingrese el
																nombre fiscal de
																su empresa</span
															>
														</template>
													</CInput>
												</ValidationProvider>
											</CCol>
										</CRow>
										<CRow
											class="content-center"
											style="text-align:left;"
										>
											<CCol sm="11">
												<div
													role="group"
													class="form-group"
												>
													<label for="typeBussines"
														>Tipo de Atención al
														Público</label
													>
													<multiselect
														@select="
															onChangeCompanyType
														"
														v-model.trim="
															formData.dataStep1
																.selectedCompanyType
														"
														:allow-empty="false"
														track-by="codeTypeBussines"
														label="nameTypeBussines"
														:options="
															formData.optionsTypeBussines
														"
														:searchable="true"
														:close-on-select="true"
														:show-labels="false"
														placeholder="Seleccione"
													>
														<span slot="noResult"
															>Oops! No se
															encontró la opción
															deseada</span
														>
													</multiselect>
													<span
														class="style-description"
														>Seleccione su tipo de
														atención al
														público</span
													>
												</div>
											</CCol>
										</CRow>
									</CCardBody>
								</CCard>
							</CCol>
						</CRow>
						<!-- ubicacion de la empresa -->
						<CRow class="content-center" style="text-align:left;">
							<CCol sm="12">
								<CCard>
									<CCardHeader>
										<strong>Ubicación de la Empresa</strong>
									</CCardHeader>
									<CCardBody>
										<!-- estado -->
										<CRow
											class="content-center"
											style="text-align:left;"
										>
											<CCol sm="11">
												<CInput
													v-model.trim="
														formData.dataStep1
															.nameState
													"
													label="Estado"
													id="state"
													disabled
												/>
											</CCol>
										</CRow>
										<!-- ciudad -->
										<CRow
											class="content-center"
											style="text-align:left;"
										>
											<CCol sm="11">
												<div
													role="group"
													class="form-group"
												>
													<label for="city"
														>Ciudad</label
													>
													<multiselect
														v-if="
															formData.dataStep1
																.citiesStateClient
																.length > 0
														"
														:allow-empty="false"
														@select="onChangeCity"
														v-model.trim="
															formData.dataStep1
																.selectedCityClient
														"
														track-by="codigociudad"
														label="nombreciudad"
														:options="
															formData.dataStep1
																.citiesStateClient
														"
														:searchable="true"
														:close-on-select="true"
														:show-labels="false"
														placeholder="Seleccione"
													>
														<span slot="noResult"
															>Oops! No se
															encontró la opción
															deseada</span
														>
													</multiselect>
													<small
														class="form-text text-muted w-100"
														>Seleccione la ciudad
														donde se encuentra su
														empresa</small
													>
												</div>
											</CCol>
										</CRow>
										<!-- urbanizacion -->
										<CRow
											class="content-center"
											style="text-align:left;"
										>
											<CCol
												v-if="
													formData.dataStep1
														.selectedUrbanzationClient !==
														0
												"
												sm="11"
											>
												<div
													role="group"
													class="form-group"
												>
													<label for="urb"
														>Urbanizaci&oacute;n</label
													>
													<multiselect
														@select="
															onChangeUrbanization
														"
														v-if="
															formData.dataStep1
																.urbanizationClientByCity
																.length > 0
														"
														:allow-empty="false"
														v-model.trim="
															formData.dataStep1
																.selectedUrbanzationClient
														"
														track-by="idUrbanization"
														label="nameUrbanization"
														:options="
															formData.dataStep1
																.urbanizationClientByCity[0]
														"
														:searchable="true"
														:close-on-select="true"
														:show-labels="false"
														placeholder="Seleccione"
													>
														<span slot="noResult"
															>Oops! No se
															encontró la opción
															deseada</span
														>
													</multiselect>
													<small
														class="form-text text-muted w-100"
														>Seleccione la
														Urbanizaci&oacute;n
														donde se encuentra su
														empresa.</small
													>
												</div>
											</CCol>
											<CCol v-else sm="11">
												<CInput
													label="Urbanización"
													id="state"
													disabled
													value="Sin Urbanización"
												/>
											</CCol>
											<!-- <CCol sm="4" style="margin-bottom: 2%;">
                                                <b-button @click="otherUrbanizationButton()" pill variant="info">Otra
                                                    Urbanización</b-button>
                                            </CCol> -->
											<!-- <CRow class="content-left">
                                            <CCol>
                                                <b-button @click="otherUrbanizationButton()" pill variant="info">Otra
                                                    Urbanización</b-button>
                                            </CCol>
                                        </CRow> -->
										</CRow>
										<!-- <CRow v-else class="content-center" style="text-align:left;">
                                            <CCol sm="7">
                                                <ValidationProvider name="Urbanización" rules='required'
                                                    v-slot="{ valid, errors }">
                                                    <CInput v-model.trim="formData.dataStep1.nameOtherUrbanization"
                                                        label="Urbanización" id="otherUrbanization" :isValid="valid"
                                                        description='Ingrese su urbanización. Si desea seleccionar una rubanización de la lista haga clic en el botón "Seleccionar Urbanización"'>
                                                        <template #invalid-feedback>
                                                            <span class="invalid-feedback">{{ errors[0] }}</span>
                                                        </template>
                                                    </CInput>
                                                </ValidationProvider>
                                            </CCol>
                                            <CCol sm="4" style="margin-bottom: 2%;">
                                                <b-button @click="selectUrbanization()" pill variant="info">Seleccionar
                                                    Urbanización</b-button>
                                            </CCol>
                                        </CRow> -->
										<!-- direccion -->
										<CRow
											class="content-center"
											style="text-align:left;"
										>
											<CCol sm="11">
												<ValidationProvider
													name="Dirección"
													:rules="{
														required_if:
															formData.dataStep1
																.codeCompanyType ==
															'F',
														customRuleAddress: {
															companyType:
																formData
																	.dataStep1
																	.codeCompanyType,
														},
													}"
													v-slot="{ valid, errors }"
												>
													<CTextarea
														@change="
															handleChange(
																'address',
																$refs.address
																	.value,
																'step1'
															)
														"
														ref="address"
														v-model.trim="
															formData.dataStep1
																.address
														"
														id="address"
														label="Dirección (Solo para tipo de atención al público en sede física)"
														vertical
														rows="10"
														:isValid="valid"
													>
														<template
															#invalid-feedback
														>
															<span
																class="invalid-feedback"
																>{{
																	errors[0]
																}}</span
															>
														</template>
														<template #description>
															<span
																class="style-description"
																>Si su tipo de
																atención al
																público es
																<b
																	>En sede
																	Física y/o
																	Virtual</b
																>
																debe indicar la
																dirección de la
																misma. En caso
																contrario no
																debe indicar la
																dirección.</span
															>
														</template>
													</CTextarea>
												</ValidationProvider>
											</CCol>
										</CRow>
										<!-- punto de referencia -->
										<CRow
											class="content-center"
											style="text-align:left;"
										>
											<CCol sm="11">
												<ValidationProvider
													name="Punto de referencia"
													:rules="{
														referencePointNotAllowed: {
															companyType:
																formData
																	.dataStep1
																	.codeCompanyType,
														},
													}"
													v-slot="{ valid, errors }"
													immediate
												>
													<CInput
														@change="
															handleChange(
																'referencePoint',
																$refs
																	.referencePoint
																	.value,
																'step1'
															)
														"
														:isValid="
															formData.dataStep1
																.codeCompanyType ==
															'V'
																? valid
																: null
														"
														ref="referencePoint"
														v-model.trim="
															formData.dataStep1
																.referencePoint
														"
														label="Punto de Referencia (Opcional)"
														id="referencePoint"
													>
														<template
															#invalid-feedback
														>
															<span
																class="invalid-feedback"
																>{{
																	errors[0]
																}}</span
															>
														</template>
														<template #description>
															<span
																class="style-description"
																>Indique un
																punto de
																referencia para
																la dirección de
																su
																empresa.</span
															>
														</template>
													</CInput>
												</ValidationProvider>
											</CCol>
										</CRow>
										<!-- servicios de la sede -->
										<CRow
											v-if="showServices"
											class="content-center"
											style="text-align:left;"
										>
											<CCol sm="11">
												<CTextarea
													@change="
														handleChange(
															'headquartersService',
															$refs
																.headquartersService
																.value,
															'step1'
														)
													"
													ref="headquartersService"
													id="headquartersService"
													v-model.trim="
														formData.dataStep1
															.headquartersService
													"
													label="Servicios de la Sede (Opcional)"
													vertical
													rows="10"
												>
													<template #description>
														<span
															class="style-description"
															>Indique que tipo de
															servicios ofrece su
															empresa.</span
														>
													</template>
												</CTextarea>
											</CCol>
										</CRow>
									</CCardBody>
								</CCard>
							</CCol>
						</CRow>
						<!-- mapa -->
						<CRow
							v-if="formData.dataStep1.codeCompanyType !== 'V'"
							class="content-center"
							style="text-align:left;"
						>
							<CCol sm="12">
								<CCard>
									<CCardHeader>
										<strong>Mapa</strong
										><small> (Opcional)</small>
									</CCardHeader>
									<CCardBody>
										<div>
											<h5>
												Para el correcto funcionamiento
												del mapa por favor permita
												compartir su ubicaci&oacute;n
											</h5>
											<br />
											<!-- no existe mapa -->
											<div
												id="no-map"
												v-if="
													!formData.dataStep1
														.infoUpdateMap
												"
											>
												<p>
													El mapa tendrá un marcador
													de forma automática tomando
													en cuenta la Urbanización,
													Ciudad y Estado de la
													empresa en una zona
													aproximada.
												</p>
												<p>
													Este marcador puede no estar
													en el lugar exacto de su
													ubicación, por lo cual
													<b
														>debe seleccionar el
														punto exacto</b
													>
													haciendo clic en su
													ubicación en el mapa o
													arrastrando el marcador
													existente, de lo contrario
													<b
														>no se guardará la
														información del mapa</b
													>.
												</p>

												<p>
													No posee mapa registrado,
													puede registrar un mapa
													haciendo clic en el botón
													<b>Registrar mapa</b>
												</p>
												<b-button
													pill
													variant="info"
													@click="showMap = true"
													:disabled="showMap"
													>Registrar mapa</b-button
												>
											</div>
											<!-- existe mapa -->
											<div id="yes-map" v-else>
												<p>
													El mapa tendrá un marcador
													de forma automática tomando
													en cuenta el mapa que ya
													tiene registrado en
													infoguia.
												</p>
												<p>
													Si desea modificar el
													marcador actual puede
													hacerlo haciendo clic en su
													ubicación exacta o
													arrastrando el mismo, de lo
													contrario
													<b
														>no se guardará la
														información del mapa</b
													>.
												</p>

												<p>
													Ya posee un mapa registrado,
													si desea puede modifcar el
													mismo haciendo clic en el
													botón <b>Modificar mapa</b>
												</p>
												<b-button
													pill
													variant="info"
													@click="showMap = true"
													:disabled="showMap"
													>Modificar mapa</b-button
												>
											</div>
										</div>
										<br />
										<!-- mostar mapa -->
										<div v-if="showMap" id="google-map">
											<p>
												<b-badge
													style="font-size: 14px;"
													variant="warning"
													>Importante:
												</b-badge>
												Si cambia su ciudad y
												urbanización
												<b
													>debe seleccionar el punto
													exacto</b
												>
												haciendo clic en su ubicación en
												el mapa o arrastrando el
												marcador existente, de lo
												contrario
												<b
													>no se guardará la
													información del mapa</b
												>.
											</p>
											<leaflet-map
												@addMarker="latLngMapClient"
												@dragMarker="latLngMapClient"
												:create-marker="
													formData.dataStep1.hasMap
														? true
														: false
												"
												:latitude="
													formData.dataStep1.hasMap
														? formData.dataStep1
																.latitude
														: 0
												"
												:longitude="
													formData.dataStep1.hasMap
														? formData.dataStep1
																.longitude
														: 0
												"
												:zoom="
													formData.dataStep1.hasMap
														? 20
														: 6
												"
												:address="
													formData.dataStep1.hasMap
														? ''
														: addresForMap
												"
												:center-geo-locate="
													formData.dataStep1.hasMap
														? false
														: true
												"
											/>
										</div>
									</CCardBody>
								</CCard>
							</CCol>
						</CRow>
					</ValidationObserver>
				</div>
			</CContainer>
		</tab-content>
		<!-- paso 2 telefonos y horarios -->
		<tab-content title="Teléfonos y Horarios" :before-change="saveStep2">
			<CContainer class="d-flex content-center min-vh-100">
				<div class="col-sm-12">
					<ValidationObserver ref="test" v-slot="{ valid }">
						<CAlert v-if="!valid" color="danger"
							>Oops!! El formulario tiene algún error. Por favor
							verifique los campos.</CAlert
						>
						<input
							type="hidden"
							id="validStep2"
							ref="validStep2"
							class="hidden"
							:value="valid"
						/>
						<!-- telefonos y whatsapp -->
						<CRow class="content-center" style="text-align:left;">
							<CCol sm="12">
								<CCard>
									<CCardHeader>
										<strong>Teléfonos y WhatsApp</strong>
									</CCardHeader>
									<CCardBody>
										<CRow
											class="content-center"
											style="text-align:left;"
										>
											<CCol sm="11">
												<ValidationProvider
													name="Teléfonos"
													:rules="{
														validMultiPhones: true,
														existAreaCode: {
															inputType:
																'textarea',
														},
													}"
													v-slot="{ valid, errors }"
													immediate
													vid="multi-phones"
													maxlength="200"
												>
													<CTextarea
														@change="
															handleChange(
																'telephone',
																$refs.telephone
																	.value,
																'step2'
															)
														"
														ref="telephone"
														v-model.trim="
															formData.dataStep2
																.telephone
														"
														id="telephone"
														label="Teléfonos"
														vertical
														rows="5"
														:isValid="valid"
													>
														<template
															#invalid-feedback
														>
															<span
																class="invalid-feedback"
																>{{
																	errors[0]
																}}</span
															>
														</template>
														<template #description>
															<span
																class="style-description"
																>Puede ingresar
																hasta cinco(5)
																números de
																teléfono
																separados por
																comas. Si desea
																incluir una
																extensión debe
																hacerlo
																ingresando un
																espacio en
																blanco y luego
																la extensión
																siguiendo el
																formato del
																siguiente
																ejemplo:
																(0212)123.4567,
																(0412)123.4567,
																(0212)123.4567
																Ext.123.</span
															>
														</template>
													</CTextarea>
												</ValidationProvider>
											</CCol>
										</CRow>
										<CRow
											class="content-center"
											style="text-align:left;"
										>
											<CCol sm="11">
												<ValidationProvider
													name="WhatsApp"
													rules="validMultiWhatsApp|cantWhatsAppTextArea"
													v-slot="{ valid, errors }"
												>
													<CTextarea
														@change="
															handleChange(
																'whatsapp',
																$refs.whatsapp
																	.value,
																'step2'
															)
														"
														ref="whatsapp"
														v-model.trim="
															formData.dataStep2
																.whatsapp
														"
														id="whatsapp"
														label="WhatsApp (Opcional)"
														vertical
														rows="5"
														:isValid="
															formData.dataStep2
																.whatsapp ==
																null ||
															formData.dataStep2
																.whatsapp == ''
																? null
																: valid
														"
													>
														<template
															#invalid-feedback
														>
															<span
																class="invalid-feedback"
																>{{
																	errors[0]
																}}</span
															>
														</template>
														<template #description>
															<span
																class="style-description"
															>
																<p>
																	Puede
																	ingresar
																	hasta tres
																	(3) números
																	de WhatsApp
																	separados
																	por comas.
																	Ej:
																	(0412)123.4567,
																	(0212)123.4567,+571239954050.
																</p>
																<p>
																	Para
																	{{
																		countryName
																	}}
																	no es
																	necesario
																	incluir el
																	codigo
																	internacional
																	{{
																		countryPhoneCode
																	}}
																</p>
															</span>
														</template>
													</CTextarea>
												</ValidationProvider>
											</CCol>
										</CRow>
									</CCardBody>
								</CCard>
							</CCol>
						</CRow>
						<!-- numeros por departamento -->
						<CRow class="content-center" style="text-align:left;">
							<CCol sm="12">
								<CCard>
									<CCardHeader>
										<strong
											>Números por Departamento</strong
										>
										<small> (Opcional)</small>
									</CCardHeader>
									<CCardBody>
										<CRow style="text-align:justify;">
											<CCol sm="11">
												Una vez seleccionado el nombre
												del departamento de la lista e
												ingresado el numero haga clic en
												el botón <b>"Agregar"</b> para
												incluirlo en la tabla de números
												por departamento. <br /><br />
												Para eliminar una opción de la
												tabla solo haga clic en el ícono
												de la papelera (<i
													class="fas fa-trash-alt fa-sm"
												></i
												>) al lado de la opción que
												desea eliminar. <br /><br />
												Ejemplos de números dedicados:
												0800-DAYCO-24, (0212)123.4567,
												(0412)123.4567.
											</CCol>
										</CRow>
										<br />
										<CRow>
											<modal-error-area-code
												v-if="errorAreaCode"
												:trigger-modal="true"
											/>
											<CCol sm="6">
												<label for="departament"
													>Departamento</label
												>
												<multiselect
													v-if="
														formData.dataInfoguia
															.selectDedicatedNumbers
															.length > 0
													"
													:allow-empty="false"
													v-model.trim="
														formData.dataStep2
															.selectedDedicatedNumbers
													"
													track-by="idtiponumero"
													label="nombre"
													:options="
														formData.dataInfoguia
															.selectDedicatedNumbers
													"
													:searchable="true"
													:close-on-select="true"
													:show-labels="false"
													placeholder="Seleccione"
												>
													<span slot="noResult"
														>Oops! No se encontró la
														opción deseada</span
													>
												</multiselect>
											</CCol>
											<CCol sm="6">
												<ValidationProvider
													name="dedicatedNumber"
													:rules="{
														validNumbersDedicated: true,
														distinctPhone:
															'@multi-phones',
													}"
													v-slot="{ valid, errors }"
												>
													<CInput
														v-model.trim="
															formData.dataStep2
																.dedicatedNumber
														"
														label="Número"
														id="dedicatedNumber"
														@keyup="
															existDedicatedNumber = false;
															formData.dataStep2
																.dedicatedNumber ===
															''
																? (formData.dataStep2.selectedDedicatedNumbers = null)
																: '';
														"
														:isValid="
															formData.dataStep2
																.dedicatedNumber ==
																null ||
															formData.dataStep2
																.dedicatedNumber ==
																''
																? null
																: !errorAreaCode
																? valid
																: false
														"
													>
														<template
															#invalid-feedback
														>
															<span
																class="invalid-feedback"
																>{{
																	errors[0]
																}}</span
															>
														</template>
													</CInput>
													<CRow class="content-left">
														<CCol>
															<b-button
																:disabled="
																	formData
																		.dataStep2
																		.dedicatedNumber ==
																		'' ||
																		!valid ||
																		formData
																			.dataStep2
																			.selectedDedicatedNumbers ==
																			null
																"
																@click="
																	addToTable(
																		formData
																			.dataStep2
																			.selectedDedicatedNumbers,
																		'tableDedicatedNumbers'
																	)
																"
																pill
																variant="success"
																>Agregar</b-button
															>
														</CCol>
													</CRow>
												</ValidationProvider>
											</CCol>
										</CRow>
										<CRow
											class="content-center"
											style="text-align:left;"
										>
											<CCol sm="11">
												<span
													v-if="existDedicatedNumber"
													ref="existDedicatedNumber"
													style="color: red;"
													>El número dedicado y/o
													departamento ya existe en la
													tabla.</span
												>
											</CCol>
										</CRow>
										<br />
										<CRow
											class="content-center"
											style="text-align:left;"
										>
											<CCol sm="11">
												<b-table
													stacked="lg"
													striped
													hover
													bordered
													:items="
														formData.dataStep2
															.tableDedicatedNumbers
													"
													:fields="
														formData.dataStep2
															.fieldsTableDedicatedNumbers
													"
												>
													<!-- slot para incluir el boton eliminar en la tabla -->
													<template
														#cell(actions)="row"
													>
														<b-button
															@click="
																deleteFromTable(
																	row,
																	'tableDedicatedNumbers'
																)
															"
															variant="danger"
															size="sm"
															class="mr-1"
														>
															<i
																class="fas fa-trash-alt"
															></i>
														</b-button>
													</template>
												</b-table>
											</CCol>
										</CRow>
									</CCardBody>
									<CCardFooter> </CCardFooter>
								</CCard>
							</CCol>
						</CRow>
						<!-- horarios de atencion -->
						<CRow class="content-center" style="text-align:left;">
							<CCol sm="12">
								<CCard>
									<CCardHeader>
										<strong>Horarios de Atención</strong>
										<small> (Opcional)</small>
									</CCardHeader>
									<CCardBody>
										<CRow style="text-align:justify;">
											<CCol sm="12">
												Seleccione en las listas el día
												y las horas de atención y
												agrégelas a la tabla haciendo
												clic en el botón
												<b>"Agregar"</b>. <br /><br />
												Para eliminar una opción de la
												tabla solo haga clic en el ícono
												de la papelera (<i
													class="fas fa-trash-alt fa-sm"
												></i
												>) al lado de la opción que
												desea eliminar.
											</CCol>
										</CRow>
										<br />
										<CRow>
											<CCol sm="6">
												<label for="businessDays"
													>Dias</label
												>
												<multiselect
													v-if="
														formData.dataInfoguia
															.selectBusinessDays
															.length > 0
													"
													:allow-empty="false"
													v-model.trim="
														formData.dataStep2
															.selectedBussinessDaysHours
															.days
													"
													track-by="iddiashorario"
													label="dias"
													:options="
														formData.dataInfoguia
															.selectBusinessDays
													"
													:searchable="true"
													:close-on-select="true"
													:show-labels="false"
													placeholder="Seleccione"
												>
													<span slot="noResult"
														>Oops! No se encontró la
														opción deseada</span
													>
												</multiselect>
											</CCol>
											<CCol sm="6">
												<label for="urb">Horas</label>
												<multiselect
													v-if="
														formData.dataInfoguia
															.selectBusinessHours
															.length > 0
													"
													:allow-empty="false"
													v-model.trim="
														formData.dataStep2
															.selectedBussinessDaysHours
															.hours
													"
													track-by="idhorashorario"
													label="hora"
													:options="
														formData.dataInfoguia
															.selectBusinessHours
													"
													:searchable="true"
													:close-on-select="true"
													:show-labels="false"
													placeholder="Seleccione"
												>
													<span slot="noResult"
														>Oops! No se encontró la
														opción deseada</span
													>
												</multiselect>
											</CCol>
										</CRow>
										<br />
										<CRow class="content-left">
											<CCol>
												<b-button
													@click="
														addToTable(
															formData.dataStep2
																.selectedBussinessDaysHours,
															'tableBussinessHours'
														)
													"
													:disabled="
														formData.dataStep2
															.selectedBussinessDaysHours
															.days == null ||
															formData.dataStep2
																.selectedBussinessDaysHours
																.hours == null
													"
													pill
													variant="success"
													>Agregar</b-button
												>
											</CCol>
										</CRow>
										<span
											v-if="existHours"
											ref="existHours"
											style="color: red;"
											>El horario de atenci&oacute;n ya
											existe en la tabla.</span
										>
										<br />
										<CRow
											class="content-center"
											style="text-align:left;"
										>
											<CCol sm="11">
												<b-table
													stacked="lg"
													striped
													hover
													bordered
													:items="
														formData.dataStep2
															.tableBussinessHours
													"
													:fields="
														formData.dataStep2
															.fieldTableBussinessHours
													"
												>
													<!-- slot para incluir el boton eliminar en la tabla -->
													<template
														#cell(actions)="row"
													>
														<b-button
															@click="
																deleteFromTable(
																	row,
																	'tableBussinessHours'
																)
															"
															variant="danger"
															size="sm"
															class="mr-1"
														>
															<i
																class="fas fa-trash-alt"
															></i>
														</b-button>
													</template>
												</b-table>
											</CCol>
										</CRow>
									</CCardBody>
									<CCardFooter> </CCardFooter>
								</CCard>
							</CCol>
						</CRow>
						<!-- formas de pago -->
						<CRow class="content-center" style="text-align:left;">
							<CCol sm="12">
								<CCard>
									<CCardHeader>
										<strong>Medios de Pago</strong>
										<small> (Opcional)</small>
									</CCardHeader>
									<CCardBody>
										<CRow style="text-align:justify;">
											<CCol sm="12">
												Seleccione una forma de pago de
												la lista y agrégela a la tabla
												haciendo clic en el botón
												<b>"Agregar"</b>. <br /><br />
												Para eliminar una opción de la
												tabla solo haga clic en el ícono
												de la papelera (<i
													class="fas fa-trash-alt fa-sm"
												></i
												>) al lado de la opción que
												desea eliminar.
											</CCol>
										</CRow>
										<br />
										<CRow>
											<CCol sm="12">
												<label for="paymentMethods"
													>Formas de Pago</label
												>
												<multiselect
													v-if="
														formData.dataInfoguia
															.selectPaymentsMethods !=
															null
													"
													:allow-empty="false"
													v-model.trim="
														formData.dataStep2
															.selectedPaymenthMethods
													"
													track-by="idformapago"
													label="nombre"
													:options="
														formData.dataInfoguia
															.selectPaymentsMethods
													"
													:searchable="true"
													:close-on-select="true"
													:show-labels="false"
													placeholder="Seleccione"
												>
													<span slot="noResult"
														>Oops! No se encontró la
														opción deseada</span
													>
												</multiselect>
											</CCol>
										</CRow>
										<br />
										<CRow class="content-left">
											<CCol>
												<b-button
													@click="
														addToTable(
															formData.dataStep2
																.selectedPaymenthMethods,
															'tablePaymentMethods'
														)
													"
													:disabled="
														formData.dataStep2
															.selectedPaymenthMethods ==
															null
													"
													pill
													variant="success"
													>Agregar</b-button
												>
											</CCol>
										</CRow>
										<span
											v-if="existPay"
											ref="existPay"
											style="color: red;"
											>El m&eacute;todo de pago
											seleccionado ya existe en la
											tabla.</span
										>
										<br />
										<CRow
											class="content-center"
											style="text-align:left;"
										>
											<CCol sm="11">
												<b-table
													stacked="lg"
													striped
													hover
													bordered
													:items="
														formData.dataStep2
															.tablePaymentMethods
													"
													:fields="
														formData.dataStep2
															.fieldsTablePaymenthMethods
													"
												>
													<!-- slot para incluir el boton eliminar en la tabla -->
													<template
														#cell(actions)="row"
													>
														<b-button
															@click="
																deleteFromTable(
																	row,
																	'tablePaymentMethods'
																)
															"
															variant="danger"
															size="sm"
															class="mr-1"
														>
															<i
																class="fas fa-trash-alt"
															></i>
														</b-button>
													</template>
												</b-table>
											</CCol>
										</CRow>
									</CCardBody>
									<CCardFooter> </CCardFooter>
								</CCard>
							</CCol>
						</CRow>
					</ValidationObserver>
				</div>
			</CContainer>
		</tab-content>
		<!-- paso 3 descripcion de la empresa -->
		<tab-content
			title="Descripción de la Empresa"
			:before-change="saveStep3"
		>
			<CContainer class="d-flex content-center min-vh-100">
				<div class="col-sm-12">
					<ValidationObserver v-slot="{ valid }">
						<CAlert v-if="!valid" color="danger"
							>Oops!! El formulario tiene algún error. Por favor
							verifique los campos.</CAlert
						>
						<input
							type="hidden"
							id="validStep3"
							ref="validStep3"
							class="hidden"
							:value="valid"
						/>
						<CRow class="content-center" style="text-align:left;">
							<CCol sm="12">
								<CCard>
									<CCardHeader>
										<strong
											>Descripción y Reseña Histórica de
											la Empresa</strong
										>
									</CCardHeader>
									<CCardBody>
										<CRow
											class="content-center"
											style="text-align:left;"
										>
											<CCol sm="12">
												<ValidationProvider
													name="Descripción de la Empresa"
													rules="required"
													v-slot="{ valid, errors }"
													immediate
												>
													<CTextarea
														@change="
															handleChange(
																'companyDescription',
																$refs
																	.companyDescription
																	.value,
																'step3'
															)
														"
														ref="companyDescription"
														id="companyDescription"
														v-model.trim="
															formData.dataStep3
																.companyDescription
														"
														vertical
														rows="10"
														:isValid="valid"
													>
														<template #label>
															Descripción de la
															empresa
															<div
																class="float-right"
															>
																<p>
																	Cantidad de
																	caracteres
																	restantes
																	<b-badge
																		pill
																		:variant="
																			countdown350CharCompanyDescription <
																			0
																				? 'danger'
																				: 'success'
																		"
																		>{{
																			countdown350CharCompanyDescription
																		}}</b-badge
																	>
																</p>
																<p
																	v-show="
																		countdown350CharCompanyDescription <
																			0
																	"
																	class="badge badge-warning"
																>
																	Evite
																	exceder los
																	350
																	caracteres
																</p>
															</div></template
														>
														<template
															#invalid-feedback
														>
															<span
																class="invalid-feedback"
																>{{
																	errors[0]
																}}</span
															>
														</template>
														<template #description>
															<CRow
																class="content-center"
																style="text-align:left;"
															>
																<CCol sm="12">
																	<p
																		class="text-left style-description"
																	>
																		Ingrese
																		una
																		breve
																		descripción
																		de su
																		empresa.
																	</p>
																</CCol>
															</CRow>
														</template>
													</CTextarea>
												</ValidationProvider>
											</CCol>
										</CRow>
										<CRow
											class="content-center"
											style="text-align:left;"
										>
											<CCol sm="12">
												<CTextarea
													@change="
														handleChange(
															'review',
															$refs.review.value,
															'step3'
														)
													"
													ref="review"
													id="review"
													v-model.trim="
														formData.dataStep3
															.review
													"
													vertical
													rows="10"
												>
													<template #label>
														Reseña Histórica
														(Opcional)
														<div
															class="float-right"
														>
															<p>
																Cantidad de
																caracteres
																restantes
																<b-badge
																	pill
																	:variant="
																		countdown500CharCompanyReview <
																		0
																			? 'danger'
																			: 'success'
																	"
																	>{{
																		countdown500CharCompanyReview
																	}}</b-badge
																>
															</p>
															<p
																v-show="
																	countdown500CharCompanyReview <
																		0
																"
																class="badge badge-warning"
															>
																Evite exceder
																los 500
																caracteres
															</p>
														</div></template
													>
													<template #description>
														<CRow
															class="content-center"
															style="text-align:left;"
														>
															<CCol sm="12">
																<p
																	class="text-left style-description"
																>
																	Ingrese una
																	breve reseña
																	histórica de
																	su empresa.
																</p>
															</CCol>
														</CRow>
													</template>
												</CTextarea>
											</CCol>
										</CRow>
									</CCardBody>
								</CCard>
							</CCol>
						</CRow>
						<!-- sucursales -->
						<CRow class="content-center" style="text-align:left;">
							<CCol sm="12">
								<CCard>
									<CCardHeader>
										<strong>Sucursales</strong
										><small> (Opcional)</small>
									</CCardHeader>
									<CCardBody>
										<CRow
											class="content-center"
											style="text-align:left;"
										>
											<CCol sm="11">
												¿La empresa tiene Sucursales?
												<CSwitch
													class="mx-1"
													color="success"
													:checked.sync="
														formData.dataStep3
															.hasBranchOffice
													"
													@update:checked="
														updateHaveBranch
													"
													variant="3d"
													labelOn="Si"
													labelOff="No"
												>
												</CSwitch>
											</CCol>
										</CRow>
										<br />
										<CRow
											v-show="
												formData.dataStep3
													.hasBranchOffice
											"
											class="content-center"
											style="text-align:left;"
										>
											<CCol sm="11">
												<p>
													A continuación por favor
													incluya la información de la
													sucursal en el siguiente
													campo
												</p>
											</CCol>
											<CCol sm="11">
												<ValidationProvider
													name="Información de Sucursales"
													:rules="{
														required_if:
															formData.dataStep3
																.hasBranchOffice,
													}"
													v-slot="{
														valid,
														errors,
														touched,
													}"
												>
													<CTextarea
														ref="branchOfficeInfo"
														v-model.trim="
															formData.dataStep3
																.branchOfficeInfo
														"
														id="branch-office-info"
														@change="
															handleChange(
																'branchOfficeInfo',
																$refs
																	.branchOfficeInfo
																	.value,
																'step3'
															)
														"
														label="Información de Sucursales"
														vertical
														rows="10"
														:isValid="valid"
													>
														<template
															#invalid-feedback
														>
															<span
																class="invalid-feedback"
																>{{
																	errors[0]
																}}</span
															>
														</template>
														<template #description>
															<span
																class="style-description"
																>Ingrese la
																informacion de
																las sucursales
																de la
																empresa.</span
															>
														</template>
													</CTextarea>
												</ValidationProvider>
											</CCol>
											<CCol sm="11">
												<CCard>
													<CCardHeader>
														<strong
															>Adjuntar
															archivo</strong
														><small>
															(Opcional)</small
														>
													</CCardHeader>
													<CCardBody>
														<CRow
															class="content-center"
															style="text-align:left;"
														>
															<CCol sm="12">
																<p>
																	A
																	continuación
																	puede
																	adjuntar 1 o
																	más archivos
																	con
																	información
																	sobre las
																	sucursales
																	haciendo
																	clic en el
																	siguiente
																	campo.
																	También
																	puede
																	arrastrar y
																	soltar los
																	archivo
																	directamente
																	en el campo.
																</p>
																<p>
																	<b-badge
																		pill
																		variant="warning"
																		>Nota:</b-badge
																	>
																	Sólo puede
																	adjuntar
																	imágenes o
																	archivos de
																	documento.
																	<b
																		>Ejemplo:</b
																	>
																	Excel, PDF,
																	Word,
																	imágenes
																	jpg,
																	imágenes
																	png.
																</p>
															</CCol>
															<CCol sm="12">
																<VueFileAgent
																	:helpText="
																		'Seleccione 1 o más archivos'
																	"
																	@delete="
																		deleteUploadedFile(
																			$event
																		)
																	"
																	ref="vueFileAgent"
																	:accept="
																		optionsVueFileAgent.accept
																	"
																	:errorText="
																		optionsVueFileAgent.errorText
																	"
																	:meta="true"
																	:maxSize="
																		optionsVueFileAgent.maxSize
																	"
																	:multiple="
																		true
																	"
																	:maxFiles="
																		optionsVueFileAgent.maxFiles
																	"
																	:deletable="
																		true
																	"
																	:uploadUrl="
																		uploadUrl
																	"
																	:uploadHeaders="
																		optionsVueFileAgent.uploadHeaders
																	"
																	theme="grid"
																	v-model="
																		formData
																			.dataStep3
																			.filesBranchOffice
																	"
																>
																</VueFileAgent>
															</CCol>
														</CRow>
													</CCardBody>
												</CCard>
											</CCol>
										</CRow>
									</CCardBody>
								</CCard>
							</CCol>
						</CRow>
					</ValidationObserver>
				</div>
			</CContainer>
		</tab-content>
		<!-- paso 4 categorias -->
		<tab-content title="Categorias" :before-change="saveStep4">
			<CContainer class="d-flex content-center min-vh-100">
				<div class="col-sm-12">
					<!-- categorias -->
					<CRow class="content-center" style="text-align:left;">
						<CCol sm="12">
							<CCard>
								<CCardHeader>
									<strong>Categorías</strong>
								</CCardHeader>
								<CCardBody>
									<CRow style="text-align:justify;">
										<CCol sm="11">
											Una vez seleccionada la categoría
											haga clic en el botón "Agregar" para
											incluirla en la tabla de categorías.
											<b>Debe incluir al menos una</b>.
											<br /><br />
											De las categorías seleccionadas,
											debe elegir una como categoría
											primaria. La categoría primaria, es
											aquella, que representa en un mayor
											grado la actividad comercial de su
											empresa.
											<br /><br />
											Adicionalmente, y de forma opcional,
											puede incluir una descripción en
											cada categoría para dar mayor
											información a los usuarios de los
											productos o servicios que
											comercializa en cada categoría.
											<br /><br />
											Para eliminar una categoría de la
											tabla solo haga clic en el ícono de
											la papelera (<i
												class="fas fa-trash-alt fa-sm"
											></i
											>) al lado de la opción que desea
											eliminar. <br /><br />
											<strong style="color:red;">
												Nota: El ícono de la papelera
												(<i
													class="fas fa-trash-alt fa-sm"
												></i
												>) solo aparecerá si la tabla
												tiene mas de una categoría.
											</strong>
											<!-- <br><br> <strong style="color:red;"> Nota 3: Si el switch para seleccionar
                                                una categoría raíz aparece deshabilitado es por que ya selecciono una
                                                como categoría raíz. </strong> -->
										</CCol>
									</CRow>
									<br />
									<CRow>
										<CCol sm="11">
											<label for="businessDays"
												>Categoría</label
											>
											<multiselect
												v-model.trim="
													formData.dataStep4
														.selectedCategories
												"
												:allow-empty="false"
												v-if="
													formData.dataInfoguia
														.selectCategories !=
														null
												"
												track-by="codigocategoria"
												label="nombrecategoria"
												:options="
													formData.dataInfoguia
														.selectCategories
												"
												:searchable="true"
												:close-on-select="true"
												:show-labels="false"
												placeholder="Seleccione"
											>
												<span slot="noResult"
													>Oops! No se encontró la
													opción deseada</span
												>
											</multiselect>
										</CCol>
									</CRow>
									<br />
									<CRow class="content-left">
										<CCol>
											<b-button
												v-if="
													formData.dataStep4
														.tableCategories
														.length < 4
												"
												@click="
													addToTable(
														formData.dataStep4
															.selectedCategories,
														'tableCategories'
													)
												"
												:disabled="
													formData.dataStep4
														.selectedCategories ==
														null
												"
												pill
												variant="success"
												>Agregar</b-button
											>
										</CCol>
									</CRow>
									<span
										v-if="this.existCat"
										ref="existCat"
										style="color: red;"
										>La categor&iacute;a seleccionada ya
										existe en la tabla.</span
									>
									<br />
									<CRow
										class="content-center"
										style="text-align:left;"
									>
										<CCol sm="12">
											<b-table
												stacked="lg"
												striped
												hover
												bordered
												:items="
													formData.dataStep4
														.tableCategories
												"
												:fields="
													formData.dataStep4
														.fieldsTableCategories
												"
											>
												<template
													#cell(rootCheck)="row"
												>
													<CSwitch
														class="mx-1"
														color="success"
														:checked.sync="
															row.item.rootCheck
														"
														variant="3d"
														labelOn="Si"
														labelOff="No"
														@update:checked="
															rootCheckbox(
																row.item
															)
														"
														:value="
															row.item.idCategorie
														"
													/>
												</template>
												<!-- slot para la descripcion -->
												<template
													#cell(description)="row"
												>
													<CTextarea
														v-model.trim="
															row.item.description
														"
														:id="
															'description_' +
																row.index
														"
														placeholder="Puede incluir productos, servicios y marcas"
														vertical
														rows="5"
														:ref="
															'description' +
																row.index
														"
														@keyup="
															counterCateDescription(
																row.item
															)
														"
													>
														<template #description>
															<CRow
																class="content-center"
																style="text-align:left;"
															>
																<CCol sm="12">
																	<p
																		class="text-left style-description"
																	>
																		Ingrese
																		una
																		breve
																		descripción.
																	</p>
																</CCol>
															</CRow>
														</template>
														<template #label>
															<div
																class="float-right"
															>
																<p>
																	Cantidad de
																	caracteres
																	restantes
																	<b-badge
																		pill
																		:variant="
																			row
																				.item
																				.counterCharDescription <
																			0
																				? 'danger'
																				: 'success'
																		"
																		>{{
																			row
																				.item
																				.counterCharDescription
																		}}</b-badge
																	>
																</p>
																<p
																	v-show="
																		row.item
																			.counterCharDescription <
																			0
																	"
																	class="badge badge-warning"
																	style="white-space: normal"
																>
																	Evite
																	exceder los
																	350
																	caracteres
																</p>
															</div></template
														>
													</CTextarea>
												</template>
												<!-- slot para incluir el boton eliminar en la tabla -->
												<template #cell(actions)="row">
													<b-button
														v-if="
															formData.dataStep4
																.tableCategories
																.length > 1
														"
														@click="
															deleteFromTable(
																row,
																'tableCategories'
															)
														"
														variant="danger"
														size="sm"
														class="mr-1"
													>
														<i
															class="fas fa-trash-alt"
														></i>
													</b-button>
												</template>
											</b-table>
										</CCol>
									</CRow>
								</CCardBody>
							</CCard>
						</CCol>
					</CRow>
					<!-- productos/servicios categorias -->
					<CRow class="content-center" style="text-align:left;">
						<CCol sm="12">
							<CCard>
								<CCardHeader>
									<strong
										>Productos y servicios de las
										categorías</strong
									>
									<small> (Opcional)</small>
								</CCardHeader>
								<CCardBody>
									<CRow style="text-align:justify;">
										<CCol sm="11">
											Puede seleccionar uno o más
											productos y servicios por categoría
											en el campo que se encuentra junto a
											cada categoría. Una vez seleccionado
											el producto/servicio que desea el
											mismo se añadirá automáticamente a
											la tabla.
										</CCol>
									</CRow>
									<br />
									<CRow
										class="content-center"
										style="text-align:left;"
									>
										<CCol sm="11">
											<b-table
												stacked="lg"
												striped
												hover
												bordered
												:items="
													formData.dataStep4
														.tableCategories
												"
												:fields="
													formData.dataStep4
														.fieldsTableProductsServices
												"
											>
												<template
													#cell(selectProductsServices)="row"
												>
													<multiselect
														:allow-empty="true"
														:multiple="true"
														v-model.trim="
															row.item
																.productsServices
														"
														v-if="
															row.item
																.selectProductsServices
																.length > 0
														"
														track-by="idproductos_servicios"
														label="nombre"
														:options="
															row.item
																.selectProductsServices
														"
														:searchable="true"
														:close-on-select="true"
														:show-labels="false"
														placeholder="Seleccione uno o mas productos/servicios"
													>
														<span slot="noResult"
															>Oops! No se
															encontró la opción
															deseada</span
														>
													</multiselect>
													<span v-else
														>No existen
														productos/servicios
														registrados en Infoguia
														para esta
														categoría.</span
													>
													<div class="content-right">
														<b-button
															v-if="
																row.item
																	.productsServices
																	.length > 1
															"
															@click="
																clearAllMultiSelect(
																	row,
																	'productsServices'
																)
															"
															variant="outline-secondary"
															size="sm"
															class="mr-1"
															style="margin: 2%;"
															>Limpiar
															<!-- <i class="fas fa-trash-alt"></i> -->
														</b-button>
													</div>
												</template>
												<template #cell(actions)="row">
													<b-button
														v-if="
															formData.dataStep4
																.tableCategories
																.length > 1
														"
														@click="
															deleteFromTables(
																row,
																'tableCategories'
															)
														"
														variant="danger"
														size="sm"
														class="mr-1"
													>
														<i
															class="fas fa-trash-alt"
														></i>
													</b-button>
												</template>
												<!-- slot para incluir el boton eliminar en la tabla -->
											</b-table>
										</CCol>
									</CRow>
								</CCardBody>
							</CCard>
						</CCol>
					</CRow>
					<!-- marcas categorias -->
					<CRow class="content-center" style="text-align:left;">
						<CCol sm="12">
							<CCard>
								<CCardHeader>
									<strong>Marcas de las categorías</strong>
									<small> (Opcional)</small>
								</CCardHeader>
								<CCardBody>
									<CRow style="text-align:justify;">
										<CCol sm="11">
											Puede seleccionar una o más marcas
											por categoria en el campo que se
											encuentra junto a cada categoria.
											Una vez seleccionada la marca que
											desea la misma se añadirá
											automáticamente a la tabla.
										</CCol>
									</CRow>
									<br />
									<CRow
										class="content-center"
										style="text-align:left;"
									>
										<CCol sm="11">
											<b-table
												stacked="lg"
												striped
												hover
												bordered
												:items="
													formData.dataStep4
														.tableCategories
												"
												:fields="
													formData.dataStep4
														.fieldsTableBrands
												"
											>
												<template
													#cell(selectBrands)="row"
												>
													<multiselect
														:allow-empty="true"
														:multiple="true"
														v-model.trim="
															row.item.brands
														"
														v-if="
															row.item
																.selectBrands
																.length > 0
														"
														track-by="idmarca"
														label="nombre"
														:options="
															row.item
																.selectBrands
														"
														:searchable="true"
														:close-on-select="true"
														:show-labels="false"
														placeholder="Seleccione una o mas marcas"
													>
														<span slot="noResult"
															>Oops! No se
															encontró la opción
															deseada</span
														>
													</multiselect>
													<span v-else
														>No existen marcas
														registradas en Infoguia
														para esta
														categoría.</span
													>
													<div class="content-right">
														<b-button
															v-if="
																row.item.brands
																	.length > 1
															"
															@click="
																clearAllMultiSelect(
																	row,
																	'brands'
																)
															"
															variant="outline-secondary"
															size="sm"
															class="mr-1"
															style="margin: 2%;"
															>Limpiar
															<!-- <i class="fas fa-trash-alt"></i> -->
														</b-button>
													</div>
												</template>
												<!-- slot para incluir el boton eliminar en la tabla -->
												<!-- <template #cell(actions)="row">
                                                    <multiselect
                                                        :allow-empty="true" :multiple="true" v-model.trim="row.item.productsServices"
                                                        v-if="formData.dataInfoguia.selectProductsServices != null"
                                                        track-by="idproductos_servicios" label="nombre"
                                                        :options="formData.dataInfoguia.selectProductsServices" :searchable="true"
                                                        :close-on-select="true" :show-labels="false" placeholder="Seleccione una de sus catgeorías">
                                                    </multiselect>
                                                <span>{{row.item.productsServices}}</span>
                                                </template> -->
											</b-table>
										</CCol>
									</CRow>
								</CCardBody>
							</CCard>
						</CCol>
					</CRow>
				</div>
			</CContainer>
		</tab-content>
		<!-- paso 5 redes sociales -->
		<tab-content title="Redes Sociales" :before-change="saveStep5">
			<CContainer class="d-flex content-center min-vh-100">
				<div class="col-sm-12">
					<ValidationObserver v-slot="{ valid }">
						<CAlert v-if="!valid" color="danger"
							>Oops!! El formulario tiene algún error. Por favor
							verifique los campos.</CAlert
						>
						<input
							type="hidden"
							id="validStep5"
							ref="validStep5"
							class="hidden"
							:value="valid"
						/>
						<!-- correos -->
						<CRow class="content-center" style="text-align:left;">
							<CCol sm="12">
								<CCard>
									<CCardHeader>
										<strong
											>Correos Electr&oacute;nicos</strong
										>
									</CCardHeader>
									<CCardBody>
										<!-- email principal -->
										<CRow
											class="content-center"
											style="text-align:left;"
										>
											<CCol sm="11">
												<ValidationProvider
													name="E-Mail Principal"
													rules="required|customEmail"
													immediate
													v-slot="{ valid, errors }"
													vid="principal-email"
												>
													<CInput
														@change="
															handleChange(
																'advertisingEmail',
																$refs
																	.advertisingEmail
																	.value,
																'step5'
															)
														"
														ref="advertisingEmail"
														v-model.trim="
															formData.dataStep5
																.advertisingEmail
														"
														label="Email Principal"
														id="advertisingEmail"
														:isValid="valid"
													>
														<template
															#invalid-feedback
														>
															<span
																class="invalid-feedback"
																>{{
																	errors[0]
																}}</span
															>
														</template>
														<template #description>
															<span
																class="style-description"
																>Ingrese su
																E-Mail.</span
															>
														</template>
													</CInput>
												</ValidationProvider>
											</CCol>
										</CRow>
										<!-- email adicional -->
										<CRow
											class="content-center"
											style="text-align:left;"
										>
											<CCol sm="11">
												<ValidationProvider
													name="E-Mail Adicional"
													rules="validMultiEmails|cantEmailsTextArea|distinctEmail:@principal-email"
													v-slot="{ valid, errors }"
													immediate
												>
													<CTextarea
														@change="
															handleChange(
																'additionalEmail',
																$refs
																	.additionalEmail
																	.value,
																'step5'
															)
														"
														ref="additionalEmail"
														id="additionalEmail"
														v-model.trim="
															formData.dataStep5
																.additionalEmail
														"
														label="E-Mail Adicional (Opcional)"
														vertical
														rows="3"
														:isValid="
															formData.dataStep5
																.additionalEmail ==
																null ||
															formData.dataStep5
																.additionalEmail ==
																''
																? null
																: valid
														"
													>
														<template
															#invalid-feedback
														>
															<span
																class="invalid-feedback"
																>{{
																	errors[0]
																}}</span
															>
														</template>
														<template #description>
															<span
																class="style-description"
																>Puede ingresar
																hasta 5(cinco)
																E-Mails
																adicionales
																separados por
																comas.</span
															>
														</template>
													</CTextarea>
												</ValidationProvider>
											</CCol>
										</CRow>
									</CCardBody>
								</CCard>
							</CCol>
						</CRow>
						<!-- redes sociales y website -->
						<CRow class="content-center" style="text-align:left;">
							<CCol sm="12">
								<CCard>
									<CCardHeader>
										<strong
											>P&aacute;gina Web y Redes
											Sociales</strong
										>
										<small> (Opcional)</small>
									</CCardHeader>
									<CCardBody>
										<!-- pagina web -->
										<CRow
											class="content-center"
											style="text-align:left;"
										>
											<CCol sm="11">
												<ValidationProvider
													name="Página Web"
													rules="validWeb"
													immediate
													v-slot="{ valid, errors }"
												>
													<CInput
														@change="
															handleChange(
																'web',
																$refs.web.value,
																'step5'
															)
														"
														ref="web"
														v-model.trim="
															formData.dataStep5
																.website
														"
														label="Página Web"
														id="web"
														:isValid="
															formData.dataStep5
																.website ==
																null ||
															formData.dataStep5
																.website == ''
																? null
																: valid
														"
													>
														<template #description>
															<span
																class="style-description"
																>Ej:
																https://infoguia.com/.</span
															>
														</template>
														<template
															#invalid-feedback
														>
															<span
																class="invalid-feedback"
																>{{
																	errors[0]
																}}</span
															>
														</template>
													</CInput>
												</ValidationProvider>
											</CCol>
										</CRow>
										<!-- facebook -->
										<CRow
											class="content-center"
											style="text-align:left;"
										>
											<CCol sm="11">
												<ValidationProvider
													name="Facebook"
													rules="validFacebook"
													immediate
													v-slot="{ valid, errors }"
												>
													<CInput
														@change="
															handleChange(
																'facebook',
																$refs.facebook
																	.value,
																'step5'
															)
														"
														ref="facebook"
														v-model.trim="
															formData.dataStep5
																.facebook
														"
														label="Facebook"
														id="facebook"
														:isValid="
															formData.dataStep5
																.facebook ==
																null ||
															formData.dataStep5
																.facebook == ''
																? null
																: valid
														"
													>
														<template
															#prepend-content
														>
															<i
																class="fab fa-facebook-f"
															></i>
														</template>
														<template
															#invalid-feedback
														>
															<span
																class="invalid-feedback"
																>{{
																	errors[0]
																}}</span
															>
														</template>
														<template #description>
															<span
																class="style-description"
																>Ej:
																https://www.facebook.com/infoguiacom</span
															>
														</template>
													</CInput>
												</ValidationProvider>
											</CCol>
										</CRow>
										<!-- linkedin -->
										<CRow
											class="content-center"
											style="text-align:left;"
										>
											<CCol sm="11">
												<ValidationProvider
													name="Linkedin"
													rules="validLinkedin"
													immediate
													v-slot="{ valid, errors }"
												>
													<CInput
														@change="
															handleChange(
																'linkedin',
																$refs.linkedin
																	.value,
																'step5'
															)
														"
														ref="linkedin"
														v-model.trim="
															formData.dataStep5
																.linkedin
														"
														label="Linkedin"
														id="linkedin"
														:isValid="
															formData.dataStep5
																.linkedin ==
																null ||
															formData.dataStep5
																.linkedin == ''
																? null
																: valid
														"
													>
														<template
															#prepend-content
														>
															<i
																class="fab fa-linkedin-in"
															></i>
														</template>
														<template
															#invalid-feedback
														>
															<span
																class="invalid-feedback"
																>{{
																	errors[0]
																}}</span
															>
														</template>
														<template #description>
															<span
																class="style-description"
																>Ej:
																https://www.linkedin.com/company/infoguia-com</span
															>
														</template>
													</CInput>
												</ValidationProvider>
											</CCol>
										</CRow>
										<!-- youtube -->
										<CRow
											class="content-center"
											style="text-align:left;"
										>
											<CCol sm="11">
												<ValidationProvider
													name="Youtube"
													rules="validYoutube"
													immediate
													v-slot="{ valid, errors }"
												>
													<CInput
														@change="
															handleChange(
																'youtube',
																$refs.youtube
																	.value,
																'step5'
															)
														"
														ref="youtube"
														v-model.trim="
															formData.dataStep5
																.youtube
														"
														label="Youtube"
														id="youtube"
														:isValid="
															formData.dataStep5
																.youtube ==
																null ||
															formData.dataStep5
																.youtube == ''
																? null
																: valid
														"
													>
														<template
															#prepend-content
														>
															<i
																class="fab fa-youtube"
															></i>
														</template>
														<template
															#invalid-feedback
														>
															<span
																class="invalid-feedback"
																>{{
																	errors[0]
																}}</span
															>
														</template>
														<template #description>
															<span
																class="style-description"
																>Ej:
																https://www.youtube.com/channel/UCeG2L_S1JfDkoaGmZ2YZ6RQ</span
															>
														</template>
													</CInput>
												</ValidationProvider>
											</CCol>
										</CRow>
										<!-- instagram -->
										<CRow
											class="content-center"
											style="text-align:left;"
										>
											<CCol sm="11">
												<ValidationProvider
													name="Instagram"
													rules="validInstagram"
													immediate
													v-slot="{ valid, errors }"
												>
													<CInput
														@change="
															handleChange(
																'instagram',
																$refs.instagram
																	.value,
																'step5'
															)
														"
														ref="instagram"
														v-model.trim="
															formData.dataStep5
																.instagram
														"
														label="Instagram"
														id="instagram"
														:isValid="
															formData.dataStep5
																.instagram ==
																null ||
															formData.dataStep5
																.instagram == ''
																? null
																: valid
														"
													>
														<template
															#prepend-content
														>
															<i
																class="fab fa-instagram"
															></i>
														</template>
														<template
															#invalid-feedback
														>
															<span
																class="invalid-feedback"
																>{{
																	errors[0]
																}}</span
															>
														</template>
														<template #description>
															<span
																class="style-description"
																>Ingresar solo
																el nombre del
																perfil sin @ ni
																URL. Ej:
																infoguiacom.</span
															>
														</template>
													</CInput>
												</ValidationProvider>
											</CCol>
										</CRow>
										<!-- twitter -->
										<CRow
											class="content-center"
											style="text-align:left;"
										>
											<CCol sm="11">
												<ValidationProvider
													name="Twitter"
													rules="validTwitter"
													immediate
													v-slot="{ valid, errors }"
												>
													<CInput
														@change="
															handleChange(
																'twitter',
																$refs.twitter
																	.value,
																'step5'
															)
														"
														ref="twitter"
														v-model.trim="
															formData.dataStep5
																.twitter
														"
														label="Twitter"
														id="twitter"
														:isValid="
															formData.dataStep5
																.twitter ==
																null ||
															formData.dataStep5
																.twitter == ''
																? null
																: valid
														"
													>
														<template
															#prepend-content
														>
															<i
																class="fab fa-twitter"
															></i>
														</template>
														<template
															#invalid-feedback
														>
															<span
																class="invalid-feedback"
																>{{
																	errors[0]
																}}</span
															>
														</template>
														<template #description>
															<span
																class="style-description"
																>Ingresar solo
																el nombre del
																perfil sin @ ni
																URL. Ej:
																infoguiave.</span
															>
														</template>
													</CInput>
												</ValidationProvider>
											</CCol>
										</CRow>
									</CCardBody>
								</CCard>
							</CCol>
						</CRow>
					</ValidationObserver>
				</div>
			</CContainer>
		</tab-content>
		<!-- paso 6 datos de contacto -->
		<tab-content title="Datos de Contacto" :before-change="saveStep6">
			<CContainer class="d-flex content-center min-vh-100">
				<div class="col-sm-12">
					<ValidationObserver v-slot="{ valid }">
						<CAlert v-if="!valid" color="danger"
							>Oops!! El formulario tiene algún error. Por favor
							verifique los campos.</CAlert
						>
						<input
							type="hidden"
							id="validStep6"
							ref="validStep6"
							class="hidden"
							:value="valid"
						/>
						<!-- contacto principal -->
						<CRow class="content-center" style="text-align:left;">
							<CCol sm="12">
								<CCard>
									<CCardHeader>
										<strong>Contacto Principal</strong>
									</CCardHeader>
									<CCardBody>
										<!-- nombre contacto principal -->
										<CRow>
											<CCol sm="11">
												<ValidationProvider
													name="Nombre"
													rules="required|max:50|min:3|alpha_spaces"
													immediate
													v-slot="{ valid, errors }"
												>
													<CInput
														@change="
															handleChange(
																'nameContactManin',
																$refs
																	.nameContactManin
																	.value,
																'step6'
															)
														"
														ref="nameContactManin"
														v-model.trim="
															formData.dataStep6
																.nameContactManin
														"
														id="nameContactManin"
														label="Nombre"
														:isValid="valid"
													>
														<template
															#invalid-feedback
														>
															<span
																class="invalid-feedback"
																>{{
																	errors[0]
																}}</span
															>
														</template>
														<template #description>
															<span
																class="style-description"
																>Ingrese el
																nombre de la
																persona de
																contacto.</span
															>
														</template>
													</CInput>
												</ValidationProvider>
											</CCol>
										</CRow>
										<!-- telefono contacto principal -->
										<CRow>
											<CCol sm="11">
												<ValidationProvider
													name="Teléfono"
													rules="required|validPhone"
													immediate
													v-slot="{ valid, errors }"
												>
													<CInput
														@change="
															handleChange(
																'telephoneContactMain',
																$refs
																	.telephoneContactMain
																	.value,
																'step6'
															)
														"
														ref="telephoneContactMain"
														v-model.trim="
															formData.dataStep6
																.telephoneContactMain
														"
														id="telephoneContactMain"
														label="Teléfono"
														:isValid="valid"
													>
														<template
															#invalid-feedback
														>
															<span
																class="invalid-feedback"
																>{{
																	errors[0]
																}}</span
															>
														</template>
														<template #description>
															<span
																class="style-description"
																>Ingrese un
																teléfono de la
																persona de
																contacto.
																Ejemplo:
																(0412)123.4567.
																Puede ingresar
																solo un
																teléfono.
															</span>
														</template>
													</CInput>
												</ValidationProvider>
											</CCol>
										</CRow>
										<!-- email contacto principal -->
										<CRow>
											<CCol sm="11">
												<ValidationProvider
													name="E-Mail"
													rules="required|customEmail|max:100|min:10"
													immediate
													v-slot="{ valid, errors }"
												>
													<CInput
														@change="
															handleChange(
																'emailContactMain',
																$refs
																	.emailContactMain
																	.value,
																'step6'
															)
														"
														ref="emailContactMain"
														v-model.trim="
															formData.dataStep6
																.emailContactMain
														"
														id="emailContactMain"
														label="Email"
														:isValid="valid"
													>
														<template
															#invalid-feedback
														>
															<span
																class="invalid-feedback"
																>{{
																	errors[0]
																}}</span
															>
														</template>
														<template #description>
															<span
																class="style-description"
																>Ingrese el
																E-Mail de la
																persona de
																contacto.</span
															>
														</template>
													</CInput>
												</ValidationProvider>
											</CCol>
										</CRow>
										<!-- cargo contacto principal -->
										<CRow>
											<CCol sm="11">
												<ValidationProvider
													name="Cargo"
													rules="required|max:50|min:3|alpha_spaces"
													immediate
													v-slot="{ valid, errors }"
												>
													<CInput
														@change="
															handleChange(
																'positionContactMain',
																$refs
																	.positionContactMain
																	.value,
																'step6'
															)
														"
														ref="positionContactMain"
														v-model.trim="
															formData.dataStep6
																.positionContactMain
														"
														id="positionContactMain"
														label="Cargo"
														:isValid="valid"
													>
														<template
															#invalid-feedback
														>
															<span
																class="invalid-feedback"
																>{{
																	errors[0]
																}}</span
															>
														</template>
														<template #description>
															<span
																class="style-description"
																>Ingrese el
																cargo en la
																empresa de la
																persona de
																contacto.</span
															>
														</template>
													</CInput>
												</ValidationProvider>
											</CCol>
										</CRow>
									</CCardBody>
								</CCard>
							</CCol>
						</CRow>
						<!-- contacto secundario -->
						<CRow class="content-center" style="text-align:left;">
							<CCol sm="12">
								<CCard>
									<CCardHeader>
										<strong>Contacto Secundario</strong>
										<small> (Opcional)</small>
									</CCardHeader>
									<CCardBody>
										<!-- nombre contacto secundario -->
										<CRow>
											<CCol sm="11">
												<ValidationProvider
													name="Nombre Secundario"
													:rules="{
														required_if: requiredSecondaryContact,
													}"
													v-slot="{ valid, errors }"
												>
													<CInput
														@change="
															handleChange(
																'nameContactSecondary',
																$refs
																	.nameContactSecondary
																	.value,
																'step6'
															)
														"
														ref="nameContactSecondary"
														:isValid="valid"
														v-model.trim="
															formData.dataStep6
																.nameContactSecondary
														"
														id="nameContactSecondary"
														label="Nombre"
														maxlength="50"
													>
														<template
															#invalid-feedback
														>
															<span
																class="invalid-feedback"
																>{{
																	errors[0]
																}}</span
															>
														</template>
														<template #description>
															<span
																class="style-description"
																>Ingrese el
																nombre de la
																persona de
																contacto.</span
															>
														</template>
													</CInput>
												</ValidationProvider>
											</CCol>
										</CRow>
										<!-- telefono contacto secundario -->
										<CRow>
											<CCol sm="11">
												<ValidationProvider
													name="Teléfono de Contacto Secundario"
													:rules="{
														required_if: requiredSecondaryContact,
														validPhone: true,
													}"
													immediate
													v-slot="{ valid, errors }"
												>
													<CInput
														@change="
															handleChange(
																'telephoneContactSecondary',
																$refs
																	.telephoneContactSecondary
																	.value,
																'step6'
															)
														"
														ref="telephoneContactSecondary"
														v-model.trim="
															formData.dataStep6
																.telephoneContactSecondary
														"
														id="telephoneContactSecondary"
														label="Teléfono"
														:isValid="valid"
													>
														<template
															#invalid-feedback
														>
															<span
																class="invalid-feedback"
																>{{
																	errors[0]
																}}</span
															>
														</template>
														<template #description>
															<span
																class="style-description"
																>Ingrese un
																teléfono de la
																persona de
																contacto.
																Ejemplo:
																(0412)123.4567.
																Puede ingresar
																solo un
																teléfono.</span
															>
														</template>
													</CInput>
												</ValidationProvider>
											</CCol>
										</CRow>
										<!-- email contacto secundario -->
										<CRow>
											<CCol sm="11">
												<ValidationProvider
													name="E-Mail de Contacto Secundario"
													id="emailContactSecondary"
													:rules="{
														required_if: requiredSecondaryContact,
														customEmail: true,
														max: 100,
														min: 10,
													}"
													immediate
													v-slot="{ valid, errors }"
												>
													<CInput
														@change="
															handleChange(
																'emailContactSecondary',
																$refs
																	.emailContactSecondary
																	.value,
																'step6'
															)
														"
														ref="emailContactSecondary"
														v-model.trim="
															formData.dataStep6
																.emailContactSecondary
														"
														id="emailContactSecondary"
														label="Email"
														:isValid="valid"
													>
														<template
															#invalid-feedback
														>
															<span
																class="invalid-feedback"
																>{{
																	errors[0]
																}}</span
															>
														</template>
														<template #description>
															<span
																class="style-description"
																>Ingrese el
																E-Mail de la
																persona de
																contacto.</span
															>
														</template>
													</CInput>
												</ValidationProvider>
											</CCol>
										</CRow>
										<!-- cargo contacto secundario -->
										<CRow>
											<CCol sm="11">
												<ValidationProvider
													name="Cargo de contacto secundario"
													id="positionContactSecondary"
													:rules="{
														required_if: requiredSecondaryContact,
													}"
													immediate
													v-slot="{ valid, errors }"
												>
													<CInput
														@change="
															handleChange(
																'positionContactSecondary',
																$refs
																	.positionContactSecondary
																	.value,
																'step6'
															)
														"
														ref="positionContactSecondary"
														v-model.trim="
															formData.dataStep6
																.positionContactSecondary
														"
														id="positionContactSecondary"
														label="Cargo"
														maxlength="50"
														:isValid="valid"
													>
														<template
															#invalid-feedback
														>
															<span
																class="invalid-feedback"
																>{{
																	errors[0]
																}}</span
															>
														</template>
														<template #description>
															<span
																class="style-description"
																>Ingrese el
																cargo dentro de
																la empresa de la
																persona de
																contacto.</span
															>
														</template>
													</CInput>
												</ValidationProvider>
											</CCol>
										</CRow>
									</CCardBody>
								</CCard>
							</CCol>
						</CRow>
					</ValidationObserver>
				</div>
			</CContainer>
		</tab-content>
		<div class="loader" v-if="loadingWizard"></div>
	</form-wizard>
</template>
<script>
	import 'leaflet/dist/leaflet.css';
	import '../../validations/validationsForm.js';
	import saveToAPI from '../../functions/saveForm';
	import LeafletMap from '../../components/leafletMap';
	import errorAlert from '../../components/alerts/errorAlert.vue';
	import modalErrorAreaCode from '../../components/modals/modalErrorAreaCode';
	import functionsForm from '../../functions/functionsStepForm';
	import { httpCodes } from '../../constants/httpCodes';
	/**Componente que contiene el formulario llenado por el cliente para actualizar sus datos.
	 * Este componente se debe refactorizar en la fase 2
	 */
	export default {
		name: 'FormClient',
		title: 'Actualizar los Datos de su Empresa | Infoguia',
		components: {
			modalErrorAreaCode,
			errorAlert,
			LeafletMap,
		},
		data() {
			return {
				showMap: false,
				showServices: false,
				optionsVueFileAgent: {
					accept:
						'image/png,image/jpeg,image/jpg,application/pdf, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.openxmlformats-officedocument.wordprocessingml.document, .txt',
					maxSize: '5MB',
					//maxFiles: '5',
					errorText: {
						type: 'Tipo de archivo no permitido',
						size: 'El archivo no debe exceder los 5Mb',
					},
					uploadHeaders: {
						Authorization:
							'Bearer ' + sessionStorage.getItem('accessToken'),
					},
				},
				formData: {
					noError: false,
					dataClient: {},
					optionsTypeBussines: [
						{
							codeTypeBussines: '0',
							nameTypeBussines: 'Seleccione',
						},
						{
							codeTypeBussines: 'F',
							nameTypeBussines: 'En sede Física y/o Virtual',
						},
						{
							codeTypeBussines: 'V',
							nameTypeBussines: 'Únicamente Virtual',
						},
						// {
						// 	codeTypeBussines: 'D',
						// 	nameTypeBussines: 'A Domicilio',
						// },
					],
					dataStep1: {
						addressRequired: 'true',
						dif: '',
						nameCommercial: '',
						namefiscal: '',
						codeCompanyType: '',
						selectedCompanyType: null,
						idstate: '',
						nameState: '',
						idcity: '',
						areaCodeCity: 0,
						idurbanization: '',
						address: '',
						referencePoint: '',
						urlMap: '',
						headquartersService: '',
						citiesStateClient: {},
						selectedUrbanzationClient: [],
						urbanizationClientByCity: [],
						urbanizationsClient: {},
						selectedCityClient: null,
						nameOtherUrbanization: null,
						saveDataStep1: {
							record: 'ModifiedClient',
							idstate: '',
							//companyType: 'F',
						},
						hasMap: false,
						infoUpdateMap: false,
						lat: 0,
						lng: 0,
					},
					dataStep2: {
						saveDataStep2: {
							record: 'ModifiedClient',
							stepFilled: 2,
							// 'numbers': [],
							// 'schedules': [],
							// 'payments': [],
						},
						telephone: '',
						whatsapp: '',
						numeros_dedicados: null,
						dias_horarios: null,
						//valores por defecto para el select de numeros por departamente
						selectedDedicatedNumbers: null,
						//valores por defecto para el select de los dias y horas
						selectedBussinessDaysHours: {
							days: null,
							hours: null,
						},
						//valores por defecto para el select de medios de pago
						selectedPaymenthMethods: null,
						//data para la tabla de numeros por departamento
						tableDedicatedNumbers: [],
						fieldsTableDedicatedNumbers: [
							{
								key: 'type',
								label: 'Departamento',
							},
							{
								key: 'number',
								label: 'Número',
							},
							{
								key: 'actions',
								label: 'Eliminar',
							},
						],
						//data para la tabla de formas de pago
						tablePaymentMethods: [],
						fieldsTablePaymenthMethods: [
							{
								key: 'name',
								label: 'Medio de Pago',
							},
							{
								key: 'actions',
								label: 'Eliminar',
							},
						],
						dedicatedNumber: '',
						//data para la tabla de horario de atencion
						tableBussinessHours: [],
						fieldTableBussinessHours: [
							{
								key: 'days',
								label: 'Días',
							},
							{
								key: 'hours',
								label: 'Horas',
							},
							{
								key: 'actions',
								label: 'Eliminar',
							},
						],
					},
					dataStep3: {
						companyDescription: '',
						review: 'N/A',
						saveDataStep3: {
							record: 'ModifiedClient',
							stepFilled: 3,
						},
						hasBranchOffice: false,
						branchOfficeInfo: '',
						filesBranchOffice: [],
						preLoadFile: true,
						uploadUrl: '',
					},
					dataStep4: {
						//data para la tabla de categorias
						saveDataStep4: {
							record: 'ModifiedClient',
							stepFilled: 4,
							categories: [
								//'brands'= []
							],
						},
						tableCategories: [],
						fieldsTableCategories: [
							{
								key: 'categorie',
								label: 'Categoria',
							},
							{
								key: 'rootCheck',
								label: 'Categoría primaria',
							},
							{
								key: 'description',
								label: 'Descripción por categoría',
							},
							{
								key: 'actions',
								label: 'Eliminar',
							},
						],
						//data para la tabla de productos/servicios por categoria
						tableProductsServices: [],
						fieldsTableProductsServices: [
							{
								key: 'categorie',
								label: 'Categoria',
							},
							{
								key: 'selectProductsServices',
								label: 'Productos/Servicios',
							},
						],
						//data para la tabla de marcas por categorias
						tableBrands: [],
						fieldsTableBrands: [
							{
								key: 'categorie',
								label: 'Categoria',
							},
							{
								key: 'selectBrands',
								label: 'Marcas',
							},
						],
						// datos por defecto para el select de las categoria
						selectedCategories: null,
					},
					dataStep5: {
						saveDataStep5: {
							record: 'ModifiedClient',
							stepFilled: 5,
						},
						advertisingEmail: '',
						additionalEmail: '',
						website: '',
						facebook: '',
						instagram: '',
						linkedin: '',
						twitter: '',
						youtube: '',
					},
					dataStep6: {
						saveDataStep6: {
							record: 'ModifiedClient',
							stepFilled: 6,
						},
						requiredSecondaryContact: false,
						emailContactMain: '',
						emailContactSecondary: '',
						nameContactManin: '',
						nameContactSecondary: '',
						telephoneContactMain: '',
						telephoneContactSecondary: '',
						positionContactMain: '',
						positionContactSecondary: '',
					},
					dataInfoguia: {
						selectBusinessDays: [],
						selectBusinessHours: [],
						selectPaymentsMethods: null,
						selectDedicatedNumbers: [],
						selectCategories: null,
						selectBrands: null,
						selectProductsServices: null,
					},
					citiesAreaCodes: {},
				},
				httpsRegex: /^https:\/\/|^http:\/\//,
				showSelectComponent: false,
				initialStep: sessionStorage.getItem('stepFilled'),
				actualStep: 1,
				nextStep: null,
				previousStep: 0,
				loadingWizard: false,
				otherUrbanization: false,
				previousUrbanization: null,
				rootCheckboxValue: 0,
				changedFields: {},
				requestId: sessionStorage.getItem('idRequest'),
				commetRejected: null,
				existCat: false,
				existPay: false,
				existHours: false,
				errorAreaCode: false,
				errorMessageAreaCode: 'Código de Area Invalido',
				errorsAPI: '',
				countryName: process.env.VUE_APP_COUNTRY_NAME,
				countryPhoneCode: process.env.VUE_APP_COUNTRY_PHONE_CODE,
				existDedicatedNumber: false,
				max350Char: process.env.VUE_APP_350_CHAR_COUNTER,
				remaining350Char: process.env.VUE_APP_350_CHAR_COUNTER,
				max500Char: process.env.VUE_APP_500_CHAR_COUNTER,
				remaining500Char: process.env.VUE_APP_500_CHAR_COUNTER,
			};
		},
		beforeCreate: function() {},
		created() {
			let goBackUrl = sessionStorage.getItem('goBackUrl');
			if (this.formCompleted) {
				this.$router.push({
					path: goBackUrl,
				});
			} else {
				let loader = this.$loading.show();
				window.addEventListener('keypress', this.onKeyPress);
				functionsForm
					.getClientData(this.requestId)
					.then((dataClient) => {
						let dataForForm = dataClient.dataForForm;
						let originalData = dataClient.Original;
						let modifiedClient = dataClient.ModifiedClient;
						//this.commetRejected = dataClient.commetRejected != undefined && dataClient.commetRejected != null ? dataClient.commetRejected : ''
						if (dataClient.CommetRejected !== undefined) {
							this.commetRejected = {
								date: dataClient.CommetRejected.date,
								description:
									dataClient.CommetRejected.description,
								userName: dataClient.CommetRejected.user.name,
							};
						}
						//this.formData.dataClient = dataForForm
						/* -----------------------------------------PASO 1-------------------------------------------------------- */
						this.formData.dataStep1.dif =
							dataForForm.dif !== null
								? dataForForm.dif.toUpperCase()
								: '';
						this.formData.dataStep1.nameCommercial =
							dataForForm.nameCommercial;
						this.formData.dataStep1.namefiscal =
							dataForForm.namefiscal;
						this.formData.dataStep1.codeCompanyType =
							dataForForm.companyType !== null
								? dataForForm.companyType
								: '0';
						this.formData.dataStep1.idstate = dataForForm.idstate;
						this.formData.dataStep1.idcity = dataForForm.idcity;
						this.formData.dataStep1.idurbanization =
							dataForForm.idurbanization;
						if (modifiedClient) {
							if (
								modifiedClient.idcity !== 0 &&
								modifiedClient.idurbanization === 0
							) {
								this.formData.dataStep1.idurbanization = 0;
							}
						}
						//data para el nombre del estado del cliente
						functionsForm
							.getStateForClient(dataForForm.idstate)
							.then((response) => {
								this.formData.noError = true;
								this.formData.dataStep1.nameState =
									response.nombreestado;
							})
							.catch((error) => {
								console.log(error);
							});
						//ciudades segun el estado del cliente para el select
						functionsForm
							.getCitiesFromClienteState(dataForForm.idstate)
							.then((response) => {
								this.formData.noError = true;
								this.formData.dataStep1.citiesStateClient = response;
							})
							.catch((error) => {
								console.log(error);
							});
						//codigos de area de las ciudades
						functionsForm
							.allCities()
							.then((response) => {
								this.formData.citiesAreaCodes = response;
							})
							.catch((error) => {
								console.log(error);
							});
						//ciudad seleccionada del cliente
						functionsForm
							.getSelectedCityClient(
								dataForForm.idstate,
								this.formData.dataStep1.idcity
							)
							.then((response) => {
								this.formData.noError = true;
								this.formData.dataStep1.selectedCityClient =
									response[0];
								this.formData.dataStep1.areaCodeCity =
									response[0].codigotlf;
							})
							.catch((error) => {
								console.log(error);
							});
						//urbanizaciones segun el estado del cliente
						functionsForm
							.getUrbFromClientState(dataForForm.idstate)
							.then((response) => {
								this.formData.noError = true;
								this.formData.dataStep1.urbanizationsClient = response;
								let urbanizationClientByCity = response.filter(
									(el) =>
										el.codigociudad ===
										this.formData.dataStep1.idcity
								);
								this.formData.dataStep1.urbanizationClientByCity = urbanizationClientByCity.map(
									(urbanizationClientByCity) =>
										urbanizationClientByCity.urbanizations
								);
							})
							.catch((error) => {
								console.log(error);
							});
						//urbanizacion seleccionada del cliente
						if (this.formData.dataStep1.idurbanization !== 0) {
							functionsForm
								.getSelectedUrbClient(
									this.formData.dataStep1.idurbanization
								)
								.then((response) => {
									this.formData.dataStep1.selectedUrbanzationClient = response;
								})
								.catch((error) => {
									console.log(error);
								});
						} else {
							this.formData.dataStep1.selectedUrbanzationClient = 0;
						}
						//this.formData.dataStep1.nameState = modifiedClient.nameState == null ? originalData.nameState
						this.formData.dataStep1.address = dataForForm.address;
						this.formData.dataStep1.referencePoint =
							dataForForm.referencePoint;
						this.formData.dataStep1.headquartersService =
							dataForForm.headquartersService;
						//tipo de empresa seleccionada
						this.formData.dataStep1.selectedCompanyType = this.formData.optionsTypeBussines.filter(
							(el) =>
								el.codeTypeBussines ===
								this.formData.dataStep1.codeCompanyType
						);
						// this.formData.dataStep1.nameOtherUrbanization = modifiedClient.otherUrbanization se comenta por que se usara para fase 2
						// informacion para el mapa en el paso 1
						if (
							dataForForm.latitude != null &&
							dataForForm.longitude != null
						) {
							this.formData.dataStep1.hasMap = true;
							this.formData.dataStep1.infoUpdateMap = true;
							this.formData.dataStep1.latitude = parseFloat(
								dataForForm.latitude
							);
							this.formData.dataStep1.longitude = parseFloat(
								dataForForm.longitude
							);
						}
						// valores por defecto para el objeto del post del paso 1
						this.formData.dataStep1.saveDataStep1.idstate =
							dataForForm.idstate;
						/* -----------------------------------------PASO 2-------------------------------------------------------- */
						this.formData.dataStep2.telephone =
							dataForForm.telephone;
						this.formData.dataStep2.whatsapp = dataForForm.whatsapp;
						this.formData.dataStep2.dias_horarios =
							dataForForm.dias_horarios;
						this.formData.dataStep2.numeros_dedicados =
							dataForForm.numeros_dedicados;
						//select para los numeros por departamento
						functionsForm
							.getDedicatedNumbers()
							.then((response) => {
								this.formData.dataInfoguia.selectDedicatedNumbers = response;
							})
							.catch((error) => {
								console.log(error);
							});
						//tabla con los numeros dedicados del cliente
						for (
							let index = 0;
							index <
							this.formData.dataStep2.numeros_dedicados.length;
							index++
						) {
							this.formData.dataStep2.tableDedicatedNumbers[
								index
							] = {
								type: this.formData.dataStep2.numeros_dedicados[
									index
								].nombre,
								number: this.formData.dataStep2
									.numeros_dedicados[index].numeros_dedicados
									.number,
								idnumbertype: this.formData.dataStep2
									.numeros_dedicados[index].numeros_dedicados
									.idnumbertype,
							};
						}
						//data para el select de los dias laborables
						functionsForm
							.getBussinessDays()
							.then((response) => {
								this.formData.dataInfoguia.selectBusinessDays = response;
							})
							.catch((error) => {
								console.log(error);
							});
						//data para el select de las horas laborables
						functionsForm
							.getBussinessHours()
							.then((response) => {
								this.formData.dataInfoguia.selectBusinessHours = response;
							})
							.catch((error) => {
								console.log(error);
							});
						// tabla con los horarios del cliente
						for (
							let index = 0;
							index <
							this.formData.dataStep2.dias_horarios.length;
							index++
						) {
							this.formData.dataStep2.tableBussinessHours[
								index
							] = {
								days: this.formData.dataStep2.dias_horarios[
									index
								].dias,
								hours: '',
								iddayswork: this.formData.dataStep2
									.dias_horarios[index].dias_horarios
									.iddayswork,
								idhourswork: this.formData.dataStep2
									.dias_horarios[index].dias_horarios
									.idhourswork,
							};
							functionsForm
								.getHoursClient(
									this.formData.dataStep2.dias_horarios[index]
										.dias_horarios.idhourswork
								)
								.then((data) => {
									this.formData.dataStep2.tableBussinessHours[
										index
									].hours = data;
								})
								.catch((errors) => {
									console.log(errors);
								});
						}
						//select para las formas de pago
						functionsForm
							.getPaymentMethods()
							.then((response) => {
								this.formData.dataInfoguia.selectPaymentsMethods = response;
							})
							.catch((error) => {
								console.log(error);
							});
						//metodos de pago
						for (
							let index = 0;
							index < dataForForm.formas_pago.length;
							index++
						) {
							this.formData.dataStep2.tablePaymentMethods[
								index
							] = {
								name: dataForForm.formas_pago[index].nombre,
								idpaymentmethods:
									dataForForm.formas_pago[index].idformapago,
							};
						}
						/* -----------------------------------------PASO 3-------------------------------------------------------- */
						this.formData.dataStep3.companyDescription =
							dataForForm.companyDescription;
						this.formData.dataStep3.review =
							dataForForm.review != null
								? dataForForm.review
								: '';
						if (
							dataForForm.branchOfficeInfo !== null &&
							dataForForm.branchOfficeInfo !== ''
						) {
							this.formData.dataStep3.hasBranchOffice = true;
							this.formData.dataStep3.branchOfficeInfo =
								dataForForm.branchOfficeInfo;
							if (dataForForm.branch_office.length > 0) {
								this.formData.dataStep3.filesBranchOffice =
									dataForForm.branch_office;
								this.formData.dataStep3.preLoadFile = true;
							}
						}
						/* -----------------------------------------PASO 4-------------------------------------------------------- */
						// categorias de infoguia
						functionsForm
							.getInfoCategories()
							.then((data) => {
								this.formData.dataInfoguia.selectCategories = data;
							})
							.catch((errors) => {
								console.log(errors);
							});
						//marcas de infoguia
						functionsForm
							.getInfoBrands()
							.then((data) => {
								this.formData.dataInfoguia.selectBrands = data;
							})
							.catch((errors) => {
								console.log(errors);
							});
						//productos y servicios de infoguia
						functionsForm
							.getProductsServices()
							.then((data) => {
								this.formData.dataInfoguia.selectProductsServices = data;
							})
							.catch((errors) => {
								console.log(errors);
							});
						//tabla para categorias del cliente
						for (
							let index = 0;
							index < dataForForm.specific_categories.length;
							index++
						) {
							let counterCharDescription =
								dataForForm.specific_categories[index]
									.description !== null
									? this.remaining350Char -
									  dataForForm.specific_categories[index]
											.description.length
									: 350;
							this.formData.dataStep4.tableCategories[index] = {
								categorie:
									dataForForm.specific_categories[index]
										.categoria.nombrecategoria,
								rootCheck:
									dataForForm.specific_categories[index]
										.rootCategory == 'N'
										? false
										: true,
								description:
									dataForForm.specific_categories[index]
										.description,
								idCategorie:
									dataForForm.specific_categories[index]
										.idcategory,
								productsServices:
									dataForForm.specific_categories[index][
										'categories_products_services'
									],
								brands:
									dataForForm.specific_categories[index][
										'categories_brands'
									],
								selectBrands: [],
								selectProductsServices: [],
								counterCharDescription: counterCharDescription,
							};
							functionsForm
								.getBrandsByCategorie(
									dataForForm.specific_categories[index]
										.idcategory
								)
								.then((data) => {
									this.formData.dataStep4.tableCategories[
										index
									].selectBrands = data;
								})
								.catch((errors) => {
									console.log(errors);
								});
							functionsForm
								.getProductsServicesByCategorie(
									dataForForm.specific_categories[index]
										.idcategory
								)
								.then((data) => {
									this.formData.dataStep4.tableCategories[
										index
									].selectProductsServices = data;
								})
								.catch((errors) => {
									console.log(errors);
								});
							// if (dataForForm.specific_categories[index].rootCategory == 'S') {
							//     this.rootCheckboxValue++
							// }
						}
						/* -----------------------------------------PASO 5-------------------------------------------------------- */
						this.formData.dataStep5.advertisingEmail =
							dataForForm.advertisingEmail;
						this.formData.dataStep5.additionalEmail =
							dataForForm.additionalEmail;
						this.formData.dataStep5.website = dataForForm.web;
						this.formData.dataStep5.facebook = dataForForm.facebook;
						this.formData.dataStep5.instagram =
							dataForForm.instagram;
						this.formData.dataStep5.twitter = dataForForm.twitter;
						this.formData.dataStep5.linkedin = dataForForm.linkedin;
						this.formData.dataStep5.youtube = dataForForm.youtube;
						/* -----------------------------------------PASO 6-------------------------------------------------------- */
						this.formData.dataStep6.nameContactManin =
							dataForForm.nameContactManin;
						this.formData.dataStep6.nameContactSecondary =
							dataForForm.nameContactSecondary;
						this.formData.dataStep6.telephoneContactMain =
							dataForForm.telephoneContactMain;
						this.formData.dataStep6.telephoneContactSecondary =
							dataForForm.telephoneContactSecondary;
						this.formData.dataStep6.emailContactMain =
							dataForForm.emailContactMain;
						this.formData.dataStep6.emailContactSecondary =
							dataForForm.emailContactSecondary;
						this.formData.dataStep6.positionContactMain =
							dataForForm.positionContactMain;
						this.formData.dataStep6.positionContactSecondary =
							dataForForm.positionContactSecondary;
					})
					.catch(function(error) {
						// handle error
						console.log(error);
					})
					.finally(() => {
						loader.hide();
					});
			}
		},
		beforeDestroy() {
			window.removeEventListener('keypress', this.onKeyPress);
		},
		updated: function() {},
		methods: {
			onKeyPress(e) {
				this.errorsAPI = '';
			},
			updateHaveBranch() {
				let uploadData = {};
				if (!this.formData.dataStep3.hasBranchOffice) {
					this.formData.dataStep3.branchOfficeInfo = '';
					this.formData.dataStep3.filesBranchOffice = [];
					for (
						let index = 0;
						index < this.$refs.vueFileAgent.fileRecords.length;
						index++
					) {
						let fileName =
							this.$refs.vueFileAgent.fileRecords[index].upload
								.data === null
								? this.$refs.vueFileAgent.fileRecords[index]
										.file.name
								: this.$refs.vueFileAgent.fileRecords[index]
										.upload.data.data.name;
						uploadData = { data: { name: fileName } };
						this.$refs.vueFileAgent.deleteUpload(
							this.uploadUrl,
							this.optionsVueFileAgent.uploadHeaders,
							this.$refs.vueFileAgent.fileRecords[index],
							uploadData
						);
					}
					// if (this.formData.dataStep3.saveDataStep3.branchOfficeInfo !== undefined) {
					// 	delete this.formData.dataStep3.saveDataStep3.branchOfficeInfo
					// }
				}
			},
			deleteUploadedFile: function(fileRecord) {
				console.log(fileRecord);
				console.log(this.formData.dataStep3.filesBranchOffice);
				let uploadData = { data: { name: fileRecord.name() } };
				if (
					fileRecord.iddataclients !== undefined &&
					fileRecord.iddataclients !== null
				) {
					this.$refs.vueFileAgent.deleteUpload(
						this.uploadUrl,
						this.optionsVueFileAgent.uploadHeaders,
						fileRecord,
						uploadData
					);
				}
			},
			onChangeCity(selectedCity) {
				let idCity = selectedCity.codigociudad;
				const dataFromInput = {};
				this.formData.dataStep1.hasMap = false;
				this.showMap = false;
				dataFromInput['idcity'] = idCity;
				dataFromInput['latitude'] = '';
				dataFromInput['longitude'] = '';
				//codigo de area de la ciudad seleccionada
				let areaCodeForSelectedCity = this.formData.citiesAreaCodes.filter(
					(el) => el.codigociudad === selectedCity.codigociudad
				);
				this.formData.dataStep1.areaCodeCity =
					areaCodeForSelectedCity[0].codigotlf;
				this.formData.dataStep1.saveDataStep1 = Object.assign(
					{},
					this.formData.dataStep1.saveDataStep1,
					dataFromInput
				);
				for (
					let index = 0;
					index < this.formData.dataStep1.urbanizationsClient.length;
					index++
				) {
					if (
						idCity ==
						this.formData.dataStep1.urbanizationsClient[index]
							.codigociudad
					) {
						this.formData.dataStep1.urbanizationClientByCity = this.formData.dataStep1.urbanizationsClient[
							index
						].urbanizations;
					}
				}
				let urbanizationClientByCity = this.formData.dataStep1.urbanizationsClient.filter(
					(el) => el.codigociudad === idCity
				);
				this.formData.dataStep1.urbanizationClientByCity = urbanizationClientByCity.map(
					(urbanizationClientByCity) =>
						urbanizationClientByCity.urbanizations
				);
				this.formData.dataStep1.selectedUrbanzationClient = 0;
				if (
					this.formData.dataStep1.urbanizationClientByCity[0].length >
					0
				) {
					this.formData.dataStep1.selectedUrbanzationClient = null;
				}
			},
			onChangeUrbanization(selectedUrbanization) {
				const dataFromInput = {};
				this.formData.dataStep1.hasMap = false;
				this.showMap = false;
				dataFromInput['idurbanization'] =
					selectedUrbanization.idUrbanization;
				dataFromInput['typeUrbanization'] =
					selectedUrbanization.typeUrbanization;
				dataFromInput['latitude'] = '';
				dataFromInput['longitude'] = '';
				this.formData.dataStep1.saveDataStep1 = Object.assign(
					{},
					this.formData.dataStep1.saveDataStep1,
					dataFromInput
				);
			},
			onChangeCompanyType(selectedCompanyType) {
				const dataFromInput = {};
				this.errorsAPI = '';
				this.formData.dataStep1.codeCompanyType =
					selectedCompanyType.codeTypeBussines;
				if (selectedCompanyType.codeTypeBussines !== '0') {
					dataFromInput['companyType'] =
						selectedCompanyType.codeTypeBussines;
					this.formData.dataStep1.saveDataStep1 = Object.assign(
						{},
						this.formData.dataStep1.saveDataStep1,
						dataFromInput
					);
				} else {
					this.errorsAPI =
						'Debe seleccionar un tipo de atención al público';
				}
			},
			customValidationMode() {
				return { on: ['keypress', 'input'] };
			},
			addToTable(value, tableName) {
				let newObject = {}; //data para la tabla
				switch (tableName) {
					case 'tableBussinessHours':
						this.existHours = false;
						var daysExist = this.formData.dataStep2.tableBussinessHours.filter(
							(days) =>
								days.iddayswork === value.days.iddiashorario
						);
						var hoursExist = this.formData.dataStep2.tableBussinessHours.filter(
							(days) =>
								days.idhourswork === value.hours.idhorashorario
						);
						if (daysExist.length == 0 || hoursExist == 0) {
							newObject = {
								days: value.days.dias,
								iddayswork: value.days.iddiashorario,
								hours: value.hours.hora,
								idhourswork: value.hours.idhorashorario,
							};
							this.formData.dataStep2.tableBussinessHours.push(
								newObject
							);
						} else {
							this.existHours = true;
						}
						break;
					case 'tablePaymentMethods':
						this.existPay = false;
						var paymentMethodExist = this.formData.dataStep2.tablePaymentMethods.filter(
							(paymentMethod) =>
								paymentMethod.idpaymentmethods ===
								value.idformapago
						);
						if (paymentMethodExist.length == 0) {
							newObject = {
								name: value.nombre,
								idpaymentmethods: value.idformapago,
							};
							this.formData.dataStep2.tablePaymentMethods.push(
								newObject
							);
							this.formData.dataStep2.selectedPaymenthMethods = null;
						} else {
							this.existPay = true;
						}
						break;
					case 'tableDedicatedNumbers':
						this.existDedicatedNumber = false;
						var dedicatedNumberExist = this.formData.dataStep2.tableDedicatedNumbers.filter(
							(dedicatedNumbers) =>
								dedicatedNumbers.number ===
									this.formData.dataStep2.dedicatedNumber ||
								dedicatedNumbers.idnumbertype ===
									value.idtiponumero
						);
						if (dedicatedNumberExist.length == 0) {
							var startWithParenthesis =
								this.formData.dataStep2.dedicatedNumber.charAt(
									0
								) == '(';
							var localNumberDigitAfterCero = 2;
							newObject = {
								number: this.formData.dataStep2.dedicatedNumber,
								type: value.nombre,
								idnumbertype: value.idtiponumero,
							};
							if (startWithParenthesis) {
								var areaCode = this.formData.dataStep2.dedicatedNumber.substring(
									1,
									5
								);
								if (
									areaCode.charAt(1) ==
									localNumberDigitAfterCero
								) {
									functionsForm
										.getVerifyAreaCode(areaCode)
										.then((data) => {
											this.errorAreaCode = false;
											this.formData.dataStep2.tableDedicatedNumbers.push(
												newObject
											);
											this.formData.dataStep2.dedicatedNumber =
												'';
											this.formData.dataStep2.selectedDedicatedNumbers = null;
										})
										.catch((errors) => {
											console.log(errors);
											this.errorAreaCode = true;
										});
								} else {
									this.formData.dataStep2.tableDedicatedNumbers.push(
										newObject
									);
									this.formData.dataStep2.dedicatedNumber =
										'';
									this.formData.dataStep2.selectedDedicatedNumbers = null;
								}
							} else {
								this.formData.dataStep2.tableDedicatedNumbers.push(
									newObject
								);
								this.formData.dataStep2.dedicatedNumber = '';
								this.formData.dataStep2.selectedDedicatedNumbers = null;
							}
						} else {
							this.existDedicatedNumber = true;
						}
						break;
					case 'tableCategories':
						var categorieExist = this.formData.dataStep4.tableCategories.filter(
							(categorie) =>
								categorie.idCategorie === value.codigocategoria
						);
						this.existCat = false;
						if (categorieExist.length == 0) {
							newObject = {
								categorie: value.nombrecategoria,
								idCategorie: value.codigocategoria,
								rootCheck: false,
								brands: [],
								selectBrands: [],
								productsServices: [],
								selectProductsServices: [],
								counterCharDescription: 350,
							};
							functionsForm
								.getBrandsByCategorie(value.codigocategoria)
								.then((data) => {
									newObject.selectBrands = data;
								})
								.catch((errors) => {
									console.log(errors);
								});
							functionsForm
								.getProductsServicesByCategorie(
									value.codigocategoria
								)
								.then((data) => {
									newObject.selectProductsServices = data;
								})
								.catch((errors) => {
									console.log(errors);
								});
							this.formData.dataStep4.tableCategories.push(
								newObject
							);
						} else {
							this.existCat = true;
						}
						break;
				}
			},
			deleteFromTable(value, tableName) {
				let index = value.index;
				switch (tableName) {
					case 'tableBussinessHours':
						this.formData.dataStep2.tableBussinessHours.splice(
							index,
							1
						);
						break;
					case 'tablePaymentMethods':
						this.formData.dataStep2.tablePaymentMethods.splice(
							index,
							1
						);
						break;
					case 'tableDedicatedNumbers':
						this.formData.dataStep2.tableDedicatedNumbers.splice(
							index,
							1
						);
						break;
					case 'tableCategories':
						this.formData.dataStep4.tableCategories.splice(
							index,
							1
						);
						this.rootCheckboxValue =
							value.item.rootCheck === true ? 0 : 1;
						break;
				}
			},
			setLoading: function(value) {
				this.loadingWizard = value;
			},
			otherUrbanizationButton() {
				this.otherUrbanization = true;
				this.previousUrbanization = this.formData.dataStep1.selectedUrbanzationClient;
				this.formData.dataStep1.selectedUrbanzationClient = null;
			},
			selectUrbanization() {
				this.otherUrbanization = false;
				this.formData.dataStep1.nameOtherUrbanization = null;
				this.formData.dataStep1.selectedUrbanzationClient = this.previousUrbanization;
			},
			rootCheckbox(value) {
				this.formData.dataStep4.tableCategories.forEach((item) => {
					if (
						item.idCategorie != value.idCategorie &&
						item.rootCheck
					) {
						item.rootCheck = false;
					}
				});
				//this.rootCheckboxValue = value.rootCheck === true ? 1 : 0
			},
			clearAllMultiSelect(value, position) {
				let index = value.index;
				switch (position) {
					case 'productsServices':
						this.formData.dataStep4.tableCategories[
							index
						].productsServices = [];
						break;
					case 'brands':
						this.formData.dataStep4.tableCategories[
							index
						].brands = [];
						break;
				}
			},
			saveStep1: function() {
				let valid = this.$refs.validStep1.value;
				this.scrollUp();
				if (this.formData.dataStep1.codeCompanyType === '0') {
					valid = 'false';
					this.errorsAPI =
						'Debe seleccionar un tipo de atención al público';
				}
				if (valid === 'true') {
					if (
						this.formData.dataStep1.selectedUrbanzationClient === 0
					) {
						this.formData.dataStep1.saveDataStep1.idurbanization = 0;
					}
					return new Promise((resolve, reject) => {
						let loader = this.$loading.show();
						saveToAPI
							.saveStep1(
								this.formData.dataStep1.saveDataStep1,
								this.requestId
							)
							.then((response) => {
								sessionStorage.setItem(
									'idDataClients',
									response.idDataClients
								);
								sessionStorage.setItem('stepFilled', 1);
								this.errorsAPI = '';
								resolve(true);
							})
							.catch((error) => {
								console.log(error);
								let errorCode = error.response.data.code;
								if (
									errorCode === httpCodes.unprocessableEntity
								) {
									this.errorsAPI = error.response.data.error;
								}
								reject(false);
							})
							.finally(() => {
								loader.hide();
							});
					});
				}
				return false;
			},
			saveStep2: function() {
				let valid = this.$refs.validStep2.value;
				this.scrollUp();
				this.formData.dataStep2.saveDataStep2.numbers = {};
				if (valid === 'true') {
					if (
						this.formData.dataStep2.tableBussinessHours.length >= 1
					) {
						this.formData.dataStep2.saveDataStep2.schedules = {};
						for (
							let index = 0;
							index <
							this.formData.dataStep2.tableBussinessHours.length;
							index++
						) {
							this.formData.dataStep2.saveDataStep2.schedules[
								index
							] = {
								iddayswork: this.formData.dataStep2
									.tableBussinessHours[index].iddayswork,
								idhourswork: this.formData.dataStep2
									.tableBussinessHours[index].idhourswork,
							};
						}
					}
					if (
						this.formData.dataStep2.tableDedicatedNumbers.length >=
						1
					) {
						this.formData.dataStep2.saveDataStep2.numbers = {};
						for (
							let index = 0;
							index <
							this.formData.dataStep2.tableDedicatedNumbers
								.length;
							index++
						) {
							this.formData.dataStep2.saveDataStep2.numbers[
								index
							] = {
								idnumbertype: this.formData.dataStep2
									.tableDedicatedNumbers[index].idnumbertype,
								number: this.formData.dataStep2
									.tableDedicatedNumbers[index].number,
							};
						}
					}
					if (
						this.formData.dataStep2.tablePaymentMethods.length >= 1
					) {
						this.formData.dataStep2.saveDataStep2.payments = {};
						for (
							let index = 0;
							index <
							this.formData.dataStep2.tablePaymentMethods.length;
							index++
						) {
							this.formData.dataStep2.saveDataStep2.payments[
								index
							] = {
								idpaymentmethods: this.formData.dataStep2
									.tablePaymentMethods[index]
									.idpaymentmethods,
							};
						}
					}
					return new Promise((resolve, reject) => {
						let loader = this.$loading.show();
						saveToAPI
							.savePut(
								this.formData.dataStep2.saveDataStep2,
								this.requestId
							)
							.then((response) => {
								sessionStorage.setItem('stepFilled', 2);
								this.errorsAPI = '';
								resolve(true);
							})
							.catch((error) => {
								console.log(error);
								let errorCode = error.response.data.code;
								if (
									errorCode === httpCodes.unprocessableEntity
								) {
									this.errorsAPI = error.response.data.error;
								}
								reject(false);
							})
							.finally(() => {
								loader.hide();
							});
					});
				}
				return false;
			},
			saveStep3: function() {
				let valid = this.$refs.validStep3.value;
				this.scrollUp();
				if (!this.formData.dataStep3.hasBranchOffice) {
					this.formData.dataStep3.saveDataStep3.branchOfficeInfo = '';
				}
				this.formData.dataStep3.saveDataStep3.hasBranchOffice = this.formData.dataStep3.hasBranchOffice;
				if (valid === 'true') {
					return new Promise((resolve, reject) => {
						let loader = this.$loading.show();
						saveToAPI
							.savePut(
								this.formData.dataStep3.saveDataStep3,
								this.requestId
							)
							.then((response) => {
								sessionStorage.setItem('stepFilled', 3);
								this.errorsAPI = '';
								resolve(true);
							})
							.catch((error) => {
								console.log(error);
								let errorCode = error.response.data.code;
								if (
									errorCode === httpCodes.unprocessableEntity
								) {
									this.errorsAPI = error.response.data.error;
								}
								reject(false);
							})
							.finally(() => {
								loader.hide();
							});
					});
				}
				return false;
			},
			saveStep4: function() {
				this.scrollUp();
				for (
					let index = 0;
					index < this.formData.dataStep4.tableCategories.length;
					index++
				) {
					this.formData.dataStep4.saveDataStep4.categories[index] = {
						iddataclients: sessionStorage.getItem('idDataClients'),
						idcategory: this.formData.dataStep4.tableCategories[
							index
						].idCategorie,
						rootCategory: this.formData.dataStep4.tableCategories[
							index
						].rootCheck
							? 'S'
							: 'N',
					};
					//si el cliente tiene marcas en la categoria la asigno al array para el put
					if (
						this.formData.dataStep4.tableCategories[index].brands
							.length > 0
					) {
						this.formData.dataStep4.saveDataStep4.categories[
							index
						].brands = [];
						for (
							let indexBrands = 0;
							indexBrands <
							this.formData.dataStep4.tableCategories[index]
								.brands.length;
							indexBrands++
						) {
							this.formData.dataStep4.saveDataStep4.categories[
								index
							].brands[indexBrands] = {
								idbrand: this.formData.dataStep4
									.tableCategories[index].brands[indexBrands]
									.idmarca,
							};
						}
					}
					//si el cliente tiene productos/servicios en la categoria la asigno al array para el put
					if (
						this.formData.dataStep4.tableCategories[index]
							.productsServices.length > 0
					) {
						this.formData.dataStep4.saveDataStep4.categories[
							index
						].productsServices = [];
						for (
							let indexproductsServices = 0;
							indexproductsServices <
							this.formData.dataStep4.tableCategories[index]
								.productsServices.length;
							indexproductsServices++
						) {
							this.formData.dataStep4.saveDataStep4.categories[
								index
							].productsServices[indexproductsServices] = {
								idproductsservices: this.formData.dataStep4
									.tableCategories[index].productsServices[
									indexproductsServices
								].idproductos_servicios,
							};
						}
					}
					//si existe la posicion descripcion y no esta vacia en la tabla de las categorias del cliente la asigno para el array del put
					if (
						this.formData.dataStep4.tableCategories[index]
							.description !== undefined &&
						this.formData.dataStep4.tableCategories[index]
							.description !== '' &&
						this.formData.dataStep4.tableCategories[index]
							.description !== null
					) {
						this.formData.dataStep4.saveDataStep4.categories[
							index
						].description = this.formData.dataStep4.tableCategories[
							index
						].description;
					}
				}
				return new Promise((resolve, reject) => {
					let loader = this.$loading.show();
					saveToAPI
						.savePut(
							this.formData.dataStep4.saveDataStep4,
							this.requestId
						)
						.then((response) => {
							sessionStorage.setItem('stepFilled', 4);
							this.errorsAPI = '';
							resolve(true);
						})
						.catch((error) => {
							console.log(error);
							let errorCode = error.response.data.code;
							if (errorCode === httpCodes.unprocessableEntity) {
								this.errorsAPI = error.response.data.error;
							}
							reject(false);
						})
						.finally(() => {
							loader.hide();
						});
				});
			},
			saveStep5: function() {
				let valid = this.$refs.validStep5.value;
				this.scrollUp();
				let includesHttps = true;
				if (valid === 'true') {
					// https para facebook
					if (
						this.formData.dataStep5.saveDataStep5.facebook !==
							undefined &&
						this.formData.dataStep5.saveDataStep5.facebook !== ''
					) {
						includesHttps = this.httpsRegex.test(
							this.formData.dataStep5.saveDataStep5.facebook
						);
						this.formData.dataStep5.saveDataStep5.facebook = includesHttps
							? this.formData.dataStep5.saveDataStep5.facebook
							: 'https://' + this.formData.dataStep5.facebook;
					}
					// https para linkedin
					if (
						this.formData.dataStep5.saveDataStep5.linkedin !==
							undefined &&
						this.formData.dataStep5.saveDataStep5.linkedin !== ''
					) {
						includesHttps = this.httpsRegex.test(
							this.formData.dataStep5.saveDataStep5.linkedin
						);
						this.formData.dataStep5.saveDataStep5.linkedin = includesHttps
							? this.formData.dataStep5.saveDataStep5.linkedin
							: 'https://' + this.formData.dataStep5.linkedin;
					}
					// https para youtube
					if (
						this.formData.dataStep5.saveDataStep5.youtube !==
							undefined &&
						this.formData.dataStep5.saveDataStep5.youtube !== ''
					) {
						includesHttps = this.httpsRegex.test(
							this.formData.dataStep5.saveDataStep5.youtube
						);
						this.formData.dataStep5.saveDataStep5.youtube = includesHttps
							? this.formData.dataStep5.saveDataStep5.youtube
							: 'https://' + this.formData.dataStep5.youtube;
					}
					return new Promise((resolve, reject) => {
						let loader = this.$loading.show();
						saveToAPI
							.savePut(
								this.formData.dataStep5.saveDataStep5,
								this.requestId
							)
							.then((response) => {
								sessionStorage.setItem('stepFilled', 5);
								this.errorsAPI = '';
								resolve(true);
							})
							.catch((error) => {
								console.log(error);
								let errorCode = error.response.data.code;
								if (
									errorCode === httpCodes.unprocessableEntity
								) {
									this.errorsAPI = error.response.data.error;
								}
								reject(false);
							})
							.finally(() => {
								loader.hide();
							});
					});
				}
				return false;
			},
			saveStep6: function() {
				let valid = this.$refs.validStep6.value;
				this.scrollUp();
				this.formData.dataStep6.saveDataStep6.nameContactSecondary = this.formData.dataStep6.nameContactSecondary;
				this.formData.dataStep6.saveDataStep6.telephoneContactSecondary = this.formData.dataStep6.telephoneContactSecondary;
				this.formData.dataStep6.saveDataStep6.emailContactSecondary = this.formData.dataStep6.emailContactSecondary;
				this.formData.dataStep6.saveDataStep6.positionContactSecondary = this.formData.dataStep6.positionContactSecondary;
				if (valid === 'true') {
					return new Promise((resolve, reject) => {
						let loader = this.$loading.show();
						saveToAPI
							.savePut(
								this.formData.dataStep6.saveDataStep6,
								this.requestId
							)
							.then((response) => {
								this.$router.push({
									name: 'thankYouMessage',
								});
								sessionStorage.setItem('stepFilled', 6);
								sessionStorage.setItem('formCompleted', true);
								this.errorsAPI = '';
								resolve(true);
							})
							.catch((error) => {
								console.log(error);
								let errorCode = error.response.data.code;
								if (
									errorCode === httpCodes.unprocessableEntity
								) {
									this.errorsAPI = error.response.data.error;
								}
								reject(false);
							})
							.finally(() => {
								loader.hide();
							});
					});
				}
				return false;
			},
			handleChange(changedInput, valueInput, stepInput) {
				const dataFromInput = {};
				dataFromInput[changedInput] = valueInput;
				switch (stepInput) {
					case 'step1':
						this.formData.dataStep1.saveDataStep1 = Object.assign(
							{},
							this.formData.dataStep1.saveDataStep1,
							dataFromInput
						);
						break;
					case 'step2':
						this.formData.dataStep2.saveDataStep2 = Object.assign(
							{},
							this.formData.dataStep2.saveDataStep2,
							dataFromInput
						);
						break;
					case 'step3':
						this.formData.dataStep3.saveDataStep3 = Object.assign(
							{},
							this.formData.dataStep3.saveDataStep3,
							dataFromInput
						);
						break;
					case 'step5':
						this.formData.dataStep5.saveDataStep5 = Object.assign(
							{},
							this.formData.dataStep5.saveDataStep5,
							dataFromInput
						);
						break;
					case 'step6':
						this.formData.dataStep6.saveDataStep6 = Object.assign(
							{},
							this.formData.dataStep6.saveDataStep6,
							dataFromInput
						);
						break;
					default:
						break;
				}
			},
			latLngMapClient(coordinates) {
				//este evento captura el objeto markers que contiene las coordenadas
				//del mapa del componente hijo leafletMap.vue
				const dataFromInput = {};
				let markerFrom =
					coordinates[0].markerFrom !== undefined
						? coordinates[0].markerFrom
						: '';
				this.formData.dataStep1.lat = coordinates[0].position.lat;
				this.formData.dataStep1.lng = coordinates[0].position.lng;
				if (this.showMap) {
					if (markerFrom === 'user') {
						dataFromInput['latitude'] = coordinates[0].position.lat;
						dataFromInput['longitude'] =
							coordinates[0].position.lng;
					} else {
						dataFromInput['latitude'] = '';
						dataFromInput['longitude'] = '';
					}
					this.formData.dataStep1.saveDataStep1 = Object.assign(
						{},
						this.formData.dataStep1.saveDataStep1,
						dataFromInput
					);
				}
			},
			scrollUp() {
				document.getElementById('formMultiStep').scrollIntoView({
					behavior: 'smooth',
				});
			},
			uppercase() {
				this.formData.dataStep1.dif = this.formData.dataStep1.dif.toUpperCase();
			},
			counterCateDescription: function(value) {
				value.counterCharDescription =
					this.remaining350Char - value.description.length;
			},
			changePage() {
				this.scrollUp();
			},
		},
		computed: {
			requiredSecondaryContact() {
				if (
					this.formData.dataStep6.nameContactSecondary !== null &&
					this.formData.dataStep6.nameContactSecondary !== ''
				) {
					return true;
				}
				if (
					this.formData.dataStep6.telephoneContactSecondary !==
						null &&
					this.formData.dataStep6.telephoneContactSecondary !== ''
				) {
					return true;
				}
				if (
					this.formData.dataStep6.emailContactSecondary !== null &&
					this.formData.dataStep6.emailContactSecondary !== ''
				) {
					return true;
				}
				if (
					this.formData.dataStep6.positionContactSecondary !== null &&
					this.formData.dataStep6.positionContactSecondary !== ''
				) {
					return true;
				}
				return false;
			},
			uploadUrl() {
				let idDataClients =
					sessionStorage.getItem('idDataClients') !== null
						? sessionStorage.getItem('idDataClients')
						: '';
				let uploadUrl = '';
				if (idDataClients !== '') {
					let idRequestRow = sessionStorage.getItem('idRequest');
					uploadUrl =
						process.env.VUE_APP_API_URL +
						'api/v1/requestsrows/' +
						idRequestRow +
						'/dataclients/' +
						idDataClients +
						'/file';
				}
				return uploadUrl;
			},
			countdown350CharCompanyDescription() {
				return (
					this.max350Char -
					this.formData.dataStep3.companyDescription.length
				);
			},
			countdown500CharCompanyReview() {
				return this.max500Char - this.formData.dataStep3.review.length;
			},
			addresForMap() {
				let addresForMap = '';
				if (!this.formData.dataStep1.hasMap) {
					let city =
						this.formData.dataStep1.selectedCityClient !== null
							? this.formData.dataStep1.selectedCityClient
									.nombreciudad
							: '';
					let urbanization =
						this.formData.dataStep1.selectedUrbanzationClient !==
						null
							? this.formData.dataStep1.selectedUrbanzationClient
									.nameUrbanization + ', '
							: '';
					// addresForMap =
					// 	urbanization +
					// 	city +
					// 	this.formData.dataStep1.nameState +
					// 	', ' +
					// 	this.countryName;
					addresForMap = urbanization + city;
				}
				return addresForMap;
			},
			formCompleted() {
				if (sessionStorage.getItem('formCompleted') === 'true') {
					return true;
				}
				return false;
			},
		},
		watch: {},
	};
</script>
